import React, { Component } from "react";
import { Button, Checkbox, Collapse, Icon, Input, Layout, Modal, Spin, Tabs, Tooltip } from "antd";
import ReportHeader from "./ReportHeader";
import Header from "./Header";
import Assets from "./Assets";
import AnnotationWidget from "./AnnotationWidget";
import PartyInfo from "./PartyInfo";
import ConfirmationModal from "./ConfirmationModal";
import AnnotationCanvas from "./AnnotationCanvas";
import FileList from "./FileList/FileList";
import History from "./History";
import AssetUpload from "./AssetUpload";
import Mp3Icon from "../media/mp3.png";
import Notes from "./Notes";
import Placeholder from "../media/placeholder.png";
import { changeStatus, formatDate, handleGoBack, processPartyTag, setInitialBodyZoom } from "./Helpers";
import { devMode, htmlUrlPath, imageUrlPath, urlPath } from "./Settings";
import { getAuthHeader, handleErrors, hasPermissions } from "../utils/security";

const DEFAULT_WIDTH = 24;
const DEFAULT_HEIGHT = 24;

const Panel = Collapse.Panel;
/* eslint eqeqeq: 0 */

/* eslint jsx-a11y/href-no-hash: 0 */
class Details extends Component {
	constructor(props) {
		super(props);
		this.state = {
			annotationFirstLoad: false,
			annotationTabInitialized: false,
			assetTabInitialized: false,
			canCreateAnnotation: false,
			canDeleteAsset: false,
			partyTagModified: false,
			collapsed: false,
			activeTabReport: null,
			confirmationModalVisible: null,
			currentFileUrl: null,
			defaultActiveKey: this.props.defaultActiveTabReport,
			fileUrl: null,
			infoTabInitialized: false,
			isInitialized: false,
			loadConfig: this.props.loadConfig,
			matspecId: this.props.matspecId,
			newAnnotations: [],
			newAssetIds: this.props.newAssetIds,
			preflightReport: this.props.preflightReport,
			preloadingMask: false,
			previewClassName: null,
			showAnnotations: false,
			showAssets: false,
			showFiles: false,
			showHistory: false,
			showInfo: false,
			showReport: false,
			specId: null,
			strings: this.props.language,
			translations: this.props.translations || {},
			visible: this.props.visible,
			zoom: 1,
			detailsMounted: false,
			submittedMatspecs: [],
			producedMatspecs: [],
			hasVisualDescChanged: false,
			isProcessing: false,
		};
		this.handleOpenReport = this.handleOpenReport.bind(this);
		this.handleApprove = this.handleApprove.bind(this);
		this.handleZoomIn = this.handleZoomIn.bind(this);
		this.handleZoomOut = this.handleZoomOut.bind(this);
		this.handleFitIn = this.handleFitIn.bind(this);
		this.handleRealSize = this.handleRealSize.bind(this);
		this.checkPermissions = this.checkPermissions.bind(this);
		this.onOk = this.onOk.bind(this);

		fetch(urlPath + "/api/customframe?key=report&matspec=" + this.props.specId
			+ (this.props.approveAdmaterialId && this.props.approveAdmaterialId > 0 ? "&admaterial=" + this.props.approveAdmaterialId : "")
			+ "&language=" + this.props.languageCode
			+ "&internalUser=" + this.props.internal
			+ "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone,
			{ credentials: "include", headers: getAuthHeader() }
		)
			.then(response => response.json())
			.then(data => this.setState({ reportFrame: data.url }))
			.catch(e => {
				this.setState({ reportFrame: null });
				console.error("Cannot load report custom frame!", e);
			});
		const fetchUrl =
			this.props.approveAdmaterialId > 0
				? "/api/customframe?key=infotab&matspec=" + this.props.specId + "&admaterial=" + this.props.approveAdmaterialId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone
				: "/api/customframe?key=infotab&matspec=" + this.props.specId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;

		const fetchUrlAssetTab =
			this.props.approveAdmaterialId > 0
				? "/api/customframe?key=assettab&matspec=" + this.props.specId + "&admaterial=" + this.props.approveAdmaterialId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone
				: "/api/customframe?key=assettab&matspec=" + this.props.specId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;

		const fetchUrlAnnotationTab =
			this.props.approveAdmaterialId > 0
				? "/api/customframe?key=annotationtab&matspec=" + this.props.specId + "&admaterial=" + this.props.approveAdmaterialId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone
				: "/api/customframe?key=annotationtab&matspec=" + this.props.specId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;

		fetch(urlPath + fetchUrl + "&language=" + this.props.languageCode, { credentials: "include", headers: getAuthHeader() })
			.then(handleErrors)
			.then(response => response.json())
			.then(data => this.setState({ infoTabFrame: data.url }))
			.catch(e => console.error("Cannot load info tab!", e));
		fetch(urlPath + fetchUrlAssetTab + "&language=" + this.props.languageCode, { credentials: "include", headers: getAuthHeader() })
			.then(handleErrors)
			.then(response => response.json())
			.then(data => this.setState({ assetTabFrame: data.url, assetTabInitialized: true }))
			.catch(e => console.error("Cannot load assetTabFrame  tab!", e));
		fetch(urlPath + fetchUrlAnnotationTab + "&language=" + this.props.languageCode, { credentials: "include", headers: getAuthHeader() })
			.then(handleErrors)
			.then(response => response.json())
			.then(data => this.setState({
				annotationTabFrame: data.url,
				annotationTabInitialized: true
			}))
			.catch(e => console.error("Cannot load annotationTabFrame  tab!", e));
	}

	handleTerms = () => {
		const { preflightReport, specId } = this.props;
		let formattedReport = preflightReport;
		if (formattedReport && typeof formattedReport === "string")
			formattedReport = JSON.parse(formattedReport);
		//console.log("formattedReport", formattedReport);
		let termButtons = formattedReport && formattedReport.buttons && formattedReport.buttons.terms;
		//termButtons = ["APPROVE", "APPROVEWITHCHANGES"];

		const url = urlPath + "/api/customframe?key=terms_conditions&matspec=" + specId + "&language=" + this.props.languageCode + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;
		if (this.state.specId !== specId) {
			fetch(url, { credentials: "include", headers: getAuthHeader() })
				.then(response => response.json())
				.then(data => this.setState({ customFrameTerms: data.url }))
				.catch(e => console.error("error loading custom frame"));
		}
		let showTerms = false;
		let approveTerms = false;
		let approveWithChangesTerms = false;
		let correctTerms = false;
		let showApproveTerms = false;
		if (termButtons && termButtons.length > 0) {
			showTerms = true;
			for (let i = 0; i < termButtons.length; i++) {
				if (termButtons[i] === "APPROVE") {
					approveTerms = true;
					showApproveTerms = true;
				}
				if (termButtons[i] === "CORRECT") correctTerms = true;
				if (termButtons[i] === "APPROVEWITHCHANGES")
					approveWithChangesTerms = true;
			}
			this.setState({
				showTerms,
				approveTerms,
				approveWithChangesTerms,
				correctTerms,
				showApproveTerms
			});
		} else {
			this.setState({
				showTerms,
				approveTerms,
				approveWithChangesTerms,
				correctTerms,
				showApproveTerms
			});
		}
	};

	componentWillReceiveProps(nextProps) {
		this.setZoom();
		this.setState({ newAnnotations: [], preloadingMask: true, pageCount: 0 });
		const tabs = document.getElementsByClassName("ant-tabs-tab");
		for (let i = 0; i < tabs.length; i++) {
			tabs[i].setAttribute("id", "tab-" + i);
			if (tabs[i].innerHTML.includes(this.props.translations.annotations))
				tabs[i].setAttribute("id", "annotationTab");
			if (tabs[i].innerHTML.includes(this.props.translations.assets))
				tabs[i].setAttribute("id", "assetTab");
			if (tabs[i].innerHTML.includes(this.props.translations.reportTab1))
				tabs[i].setAttribute("id", "reportTab");
			if (tabs[i].innerHTML.includes(this.props.translations.partyInfo))
				tabs[i].setAttribute("id", "partyInfoTab");
		}
		this.setState({ detailsMounted: true });
		if (this.props.newAssetIds && this.props.newAssetIds !== "[]")
			this.newAssetUploaded(true);
		this.setState({
			previewClassName: "d-none",
			hasDescription: false,
			specId: nextProps.specId,
			strings: nextProps.language,
			translations: nextProps.translations,
			visible: nextProps.visible,
			approveWithChangesProgress: false,
			newNoteSaved: false
		});
		const matspec = nextProps.matspec;
		const admaterialId = nextProps.approveAdmaterialId;
		if (matspec) {
			const matspecId = nextProps.specId;
			if (!matspecId || matspecId <= 0) console.log("Dummy specId", matspecId);
			else {
				if (nextProps.changesButtons !== this.props.changesButtons)
					fetch(urlPath + "/api/customframe?key=report&matspec=" + matspecId
						+ (admaterialId && admaterialId > 0 ? "&admaterial=" + admaterialId : "")
						+ "&language=" + nextProps.languageCode + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone,
						{ credentials: "include", headers: getAuthHeader() })
						.then(response => response.json())
						.then(data => this.setState({ reportFrame: data.url }))
						.catch(e => {
							this.setState({ reportFrame: null });
							console.error("Cannot load report custom frame!", e);
						});

				const fetchUrl =
					nextProps.approveAdmaterialId > 0
						? "/api/customframe?key=infotab&matspec=" + nextProps.specId + "&admaterial=" + nextProps.approveAdmaterialId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone
						: "/api/customframe?key=infotab&matspec=" + nextProps.specId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;
				const fetchUrlAssetTab =
					nextProps.approveAdmaterialId > 0
						? "/api/customframe?key=assettab&matspec=" + nextProps.specId + "&admaterial=" + nextProps.approveAdmaterialId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone
						: "/api/customframe?key=assettab&matspec=" + nextProps.specId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;
				const fetchUrlAnnotationTab =
					nextProps.approveAdmaterialId > 0
						? "/api/customframe?key=annotationtab&matspec=" + nextProps.specId + "&admaterial=" + nextProps.approveAdmaterialId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone
						: "/api/customframe?key=annotationtab&matspec=" + nextProps.specId + "&internalUser=" + this.props.internal + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (nextProps.changesButtons !== this.props.changesButtons)
					fetch(urlPath + fetchUrl + "&language=" + nextProps.languageCode, { credentials: "include", headers: getAuthHeader() })
						.then(handleErrors)
						.then(response => response.json())
						.then(data => this.setState({ infoTabFrame: data.url }))
						.catch(e => {
							this.setState({ infoTabFrame: null });
							console.error("Cannot load info tab!", e);
						});
				if (nextProps.changesButtons !== this.props.changesButtons)
					fetch(urlPath + fetchUrlAssetTab + "&language=" + nextProps.languageCode,
						{ credentials: "include", headers: getAuthHeader() })
						.then(handleErrors)
						.then(response => response.json())
						.then(data => this.setState({ assetTabFrame: data.url }))
						.catch(e => {
							this.setState({ assetTabFrame: null });
							console.error("Cannot load assetTabFrame  tab!", e);
						});
				if (nextProps.changesButtons !== this.props.changesButtons)
					fetch(urlPath + fetchUrlAnnotationTab + "&language=" + nextProps.languageCode,
						{ credentials: "include", headers: getAuthHeader() })
						.then(handleErrors)
						.then(response => response.json())
						.then(data => this.setState({ annotationTabFrame: data.url }))
						.catch(e => {
							this.setState({ annotationTabFrame: null });
							console.error("Cannot load annotationTabFrame  tab!", e);
						});
				if (!nextProps.assetView && (!this.state.annotationFirstLoad || nextProps.approveAdmaterialId !== this.props.approveAdmaterialId)) {
					this.setState({ annotationFirstLoad: true })
					const assetVisualId = nextProps.assetVisualId || "";
					fetch(`${urlPath}/api/loadannotations?matspec=${matspecId}&asset=${assetVisualId}&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`,
						{ credentials: "include", headers: getAuthHeader() })
						.then(response => response.json())
						.then(data => this.setState({ annotations: data }))
						.catch(e => console.error("Cannot load annotations!", e));
				}

				if (nextProps.assetVisualId && nextProps.assetView)
					fetch(urlPath + "/api/loadannotationsasset?asset=" + nextProps.assetVisualId + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone,
						{ credentials: "include", headers: getAuthHeader() })
						.then(response => response.json())
						.then(data => this.setState({ annotations: data }))
						.catch(e => console.error("Cannot load asset annotations!", e));
			}
			this.setState({
				changesButtons: nextProps.changesButtons,
				strings: nextProps.language,
				matspec: matspec,
				admaterialid: nextProps.approveAdmaterialId,
				matspecId: matspecId,
				previewClassName: "report-preview",
				partyTagModified: false
			});
		} else
			console.log("Details: no matspec received yet");

		this.readMatspecMaterials();
		setTimeout(() => this.handleTerms(), 500);
	}

	switchView = checked => {
		//console.log("checked:", checked);
	};
	getIframeBody = iframe => {
		let innerFrame = iframe.contentWindow || iframe.contentDocument;
		innerFrame = !devMode &&
			innerFrame &&
			innerFrame.document &&
			innerFrame.document.body &&
			innerFrame.document.body.getElementsByTagName("iframe")[0];
		if (innerFrame)
			return this.getIframeBody(innerFrame);
		return iframe;
	};
	handleFrameStyles = zoom => {
		let x = document.getElementById("previewFrame");
		if (x) {
			setTimeout(() => {
				x.style.visibility = "visible"; //This will revert visibility:hidden from ReportHeader.js playAd function
			}, 250);
		}
	};

	playInnerAd = () => {
		let x = document.getElementById("previewFrame");
		const ReportPreviewContainer = document.getElementById("ReportPreviewContainer");
		if (this.canAccessIFrame(x)) {
			if (x && !devMode && ReportPreviewContainer.classList.contains("animation-true")) {
				let y = x.contentWindow || x.contentDocument;
				if (y.document) y = y.document;
				if (y.body)
					if (y.body.querySelectorAll("video")[0])
						y.body.querySelectorAll("video")[0].play();
			}
		}
	};

	handleZoomIn(props) {
		this.setState({
			zoom: props,
			previewClassName: "report-preview"
		});
		if (!devMode) this.handleFrameStyles(props);
	}

	handleFitIn() {
		const defaultZoom = this.state.defaultZoom;
		this.setState({
			zoom: defaultZoom,
			previewClassName: "report-preview"
		});
		if (!devMode) this.handleFrameStyles(defaultZoom);
	}

	handleZoomOut(props) {
		this.setState({ zoom: props });
		if (!devMode) this.handleFrameStyles(props);
	}

	handleRealSize() {
		const zoom = 1;
		this.setState({
			zoom: zoom,
			previewClassName: "report-preview"
		});
		if (!devMode) this.handleFrameStyles(zoom);
	}

	onCollapse = collapsed => this.setState({ collapsed });

	handleResubmit = e => {
		let initialStatus = null;
		const { approveAdmaterialId, specId, loadBookingData } = this.props;
		let url = "/api/admaterialdiscard?matspec=" + specId + "&admaterial=" + approveAdmaterialId + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;
		for (let i = 0; i < loadBookingData.matspecs.length; i++) {
			for (let j = 0; j < loadBookingData.matspecs[i].admaterial.length; j++) {
				if (loadBookingData.matspecs[i].admaterial[j].id === approveAdmaterialId)
					initialStatus = loadBookingData.matspecs[i].admaterial[j].initialStatus;
			}
		}
		if (initialStatus)
			url = url + "&status=" + initialStatus;
		fetch(urlPath + url, { method: "POST", credentials: "include", headers: getAuthHeader() })
			.then(response => {
				if (this.state.detailsMode) {
					let browserUrl = new URL(window.location.href);
					browserUrl = browserUrl.href;
					let backUrl = browserUrl.replace("mode=details", "");
					if (this.props.tabbedView) browserUrl = browserUrl + "&tabbedView";
					window.location.href = backUrl;
				} else
					this.props.handleAdMatRemoval();
			})
			.catch(e => {
				console.error("Cannot discard", e);
				this.props.onOk();
			});
	};
	handleCorrect = e => {
		const { approveAdmaterialId, specId } = this.props;
		let url = "/api/admaterialcommit?approve_correct=false&matspec=" + specId + "&admaterial=" + approveAdmaterialId;
		fetch(urlPath + url, { method: "POST", credentials: "include", headers: getAuthHeader() })
			.then(response => this.props.onOk())
			.catch(e => {
				console.error("Cannot correct", e);
				this.props.onOk();
			});
	};

	handleOpenReport = htmlLogUrl => {
		const url = htmlUrlPath + htmlLogUrl;
		const win = window.open(url, "_blank");
		win.focus();
	};

	handleApprove(text, val) {
		const comp = this;
		this.setState({
			confirmationModalVisible: true,
			visible: false,
			confirmationModalText: text,
			approveTrue: val
		},
			function () {
				setTimeout(() => comp.setState({ confirmationModalVisible: true }), 0);
			}
		);
	}

	handleAnnotation = type => {
		// get image dimensions
		const img = document.getElementById("previewImage");
		if (type === "FRAME" || type === "HIGHLIGHT") {
			const dummyFrameContainer = document.getElementById("dummyFrameContainer");
			if (dummyFrameContainer) dummyFrameContainer.style.display = "block";
		}
		if (img) {
			const naturalWidth = img.naturalWidth;
			const naturalHeight = img.naturalHeight;
			let width = img.clientWidth;
			let height = img.clientHeight;
			if (naturalWidth) width = naturalWidth;
			if (naturalHeight) height = naturalHeight;
			this.setState({
				canvasWidth: width,
				canvasHeight: height,
				annotationType: type
			});
		}
	};

	getPreviewSize = () => {
		// get image dimensions
		const img = document.getElementById("previewImage");
		if (img) {
			const naturalWidth = img.naturalWidth;
			const naturalHeight = img.naturalHeight;
			let width = img.clientWidth;
			let height = img.clientHeight;
			if (naturalWidth) width = naturalWidth;
			if (naturalHeight) height = naturalHeight;
			this.setState({
				canvasWidth: width,
				canvasHeight: height
			});
		}
	};

	canAccessIFrame = iframe => {
		var html = null;
		try {
			var doc = iframe.contentDocument || iframe.contentWindow.document;
			html = doc.body.innerHTML;
		} catch (err) {
		}
		return html !== null;
	};
	reportIframeLoaded = id => {
		const bodyZoom = document.body.style.zoom;
		const that = this;
		const report = typeof this.props.preflightReport === "string"
			? JSON.parse(this.props.preflightReport)
			: this.props.preflightReport;
		let partyTagAd = null;
		if (report) partyTagAd = report.partyTagAd;

		/* GET IFRAME SRC INSIDE IFRAME */
		const canAccess = this.canAccessIFrame(document.getElementById(id));
		const iframe = document.getElementById(id);
		let elmntBody = null;
		let elmntBodyPartyTag = null;
		if (canAccess) {
			/*console.log("hasClickTag", this.props.hasClickTag);
      if (!this.props.hasClickTag) {
        if (iframe.contentWindow.document.getElementById("urlChk")) {
          iframe.contentWindow.document.getElementById("urlChk").click();
        }
      }*/
			if (iframe.contentWindow.document.getElementsByTagName("html"))
				elmntBody = iframe.contentWindow.document.getElementsByTagName("html")[0];
			elmntBodyPartyTag = elmntBody.getAttribute("data-ix-thirdparty");
			if (elmntBodyPartyTag && elmntBodyPartyTag === "url") {
				let elmnt = null;
				if (iframe.contentWindow.document.getElementsByTagName("iframe")) {
					elmnt = iframe.contentWindow.document.getElementsByTagName("iframe")[0];
					if (elmnt) {
						iframe.src = elmnt.getAttribute("src");
						iframe.style.height = "75vh";
						iframe.width = "100%";
					}
				}
			}
		}

		if (!devMode && (!elmntBodyPartyTag || elmntBodyPartyTag !== "url")) {
			const iFrameID = document.getElementById(id);
			if (this.canAccessIFrame(iFrameID))
				setTimeout(function () {
					if (iFrameID && iFrameID.contentWindow && iFrameID.contentWindow.document.body) {
						iFrameID.height = "";
						if (bodyZoom)
							iFrameID.height = (iFrameID.contentWindow.document.body.scrollHeight + 30) / bodyZoom + "px";
						else
							iFrameID.height = iFrameID.contentWindow.document.body.scrollHeight + 30 + "px";
						const partyFrame = iFrameID.contentWindow.document.getElementById("partyFrame");
						if (!partyTagAd && partyFrame)
							partyFrame.style.display = "none";
						that.setExpandablePanels();
					}
				}, 500);
		}
		if (id === "previewFrame") {
			setTimeout(() => {
				this.getPreviewSize();
				const iFrameID = document.getElementById(id);
				const canAccess = this.canAccessIFrame(document.getElementById(id));
				if (canAccess)
					iFrameID.contentWindow.document.body.style.overflow = "hidden";
			}, 500);
		}

		if (id === "assetTabFrame") {
			const that = this;
			setTimeout(() => {
				if (this.canAccessIFrame(document.getElementById(id))) {
					const textField = iframe.contentDocument.getElementById("description");
					if (textField) {
						textField.addEventListener("keydown", function () {
							setTimeout(function () {
								if (textField.value.length > 0) {
									that.setState({ hasDescription: true });
									const submitButton = document.getElementById("ad-submit-assets");
									const sendButton = document.getElementById(" ad-send-production");
									if (submitButton) submitButton.classList.remove("d-none");
									if (sendButton) sendButton.classList.remove("d-none");
								} else {
									that.setState({ hasDescription: false });
									const submitButton = document.getElementById("ad-submit-assets");
									const sendButton = document.getElementById(" ad-send-production");
									if (submitButton) submitButton.classList.add("d-none");
									if (sendButton) sendButton.classList.add("d-none");
								}
							}, 500);
						});

						textField.addEventListener("change", function () {
							if (!that.state.showProductionAdButtons) {
								that.setState({ showProductionAdButtons: true })
							}
						})
					}
				}
			}, 500);
		}
	};

	saveAnnotations = (annotation, annotationId) => {
		const matspec = this.props.matspec;
		let { newAnnotations, annotations } = this.state;
		annotations = annotations || [];
		if (annotation) {
			for (let i = 0; i < newAnnotations.length; i++) {
				if (newAnnotations[i].id === annotation.id) newAnnotations.splice(i, 1);
			}
			if (annotations)
				for (let i = 0; i < annotations.length; i++) {
					if (annotations[i].id === annotation.id) annotations.splice(i, 1);
				}
			annotation.page = this.state.pageCount ? this.state.pageCount : 0;
			newAnnotations.push(annotation);
			let parent = null;
			if (annotation.admaterial && !this.props.assetView)
				parent = "BeanRef[AdMaterial." + annotation.admaterial + "]";
			if (annotation.assetVisualId && this.props.assetView)
				parent = "BeanRef[Asset." + annotation.assetVisualId + "]";
			const newAnnotation = {
				text: annotation.text,
				id: annotation.id,
				creatorid: matspec.user.id,
				creator: {
					name: matspec.user.name,
					id: matspec.user.id
				},
				time: formatDate(new Date()),
				modificationtime: formatDate(new Date()),
				type: annotation.type,
				color: annotation.color,
				access: "Public",
				marked: false,
				page: this.state.pageCount ? this.state.pageCount : 0,
				parent: parent,
				signals: [
					{
						x: annotation.x,
						y: annotation.y,
						width: annotation.w,
						height: annotation.h,
						id: 66889
					}
				],
				comments: []
			};
			annotations.push(newAnnotation);
		} else {
			for (let i = 0; i < newAnnotations.length; i++)
				if (newAnnotations[i].id === annotationId)
					newAnnotations.splice(i, 1);
			for (let i = 0; i < annotations.length; i++)
				if (annotations[i].id === annotationId)
					annotations.splice(i, 1);
		}
		this.setState({ newAnnotations: newAnnotations, annotations: annotations });
	};

	checkFrameFieldValue = (iframeId, inputId) => {
		if (devMode) return null;
		const iframe = document.getElementById(iframeId);
		if (iframe && iframe.contentWindow.document.getElementById(inputId))
			return iframe.contentWindow.document.getElementById(inputId).value.length;
		return null;
	};

	checkAnnotations = async (mode) => {
		const assetVisualId = this.props.assetVisualId;
		if (mode === "asset") {
			const { newAnnotations } = this.state;
			for (let i = 0; i < newAnnotations.length; i++) {
				const annotation = newAnnotations[i];
				const url = urlPath + "/api/annotationsaveasset?asset=" + assetVisualId
					+ "&x=" + annotation.x + "&y=" + annotation.y + "&w=" + (annotation.w <= 0 ? DEFAULT_WIDTH : annotation.w) + "&h=" + (annotation.h <= 0 ? DEFAULT_HEIGHT : annotation.h)
					+ "&color=" + annotation.color + "&text=" + encodeURIComponent(annotation.text.replace(/\\n/g, "%0A")).replace(/%250A/g, "%0A") + "&type=" + annotation.type
					+ (annotation.annotationId ? "&id=" + annotation.annotationId : "");
				console.log("Submitting annotation (checkAnnotations)", annotation, url);
				if (annotation.annotationId)
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => console.log("Submitted note", response.text()))
						.catch(e => console.error("Cannot submit note", e));
				else {
					// Do not remove or comment out this line! It is used in UI tests!
					console.log("Submitting annotation x:" + annotation.x + " y:" + annotation.y);
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => response
							.json()
							.then(data => ({ data: data, status: response.status }))
							.then(res => {
								console.log("Annotation submitted: " + res.status + ", " + res.data);
								const annot = document.getElementsByClassName("annotation." + this.state.annotationId)[0];
								annot.classList.add("annotation." + res.data.saved);
								annot.setAttribute("data-id", "annotation." + res.data.saved);
								annot.setAttribute("id", "annotationPost." + res.data.saved);
								annot.classList.remove("annotation." + this.state.annotationId);
								this.setState({ annotationId: res.data.saved });
								document.getElementById("annotationPost." + res.data.saved).setAttribute("data-text", annotation.text);
							}))
						.catch(e => console.error("Cannot submit note", e));
				}
			}
		} else {
			const { newAnnotations } = this.state;
			this.unsubmittedChanges(false);
			if (newAnnotations.length > 0) this.setState({ newNotesSaved: true });
			for (let i = 0; i < newAnnotations.length; i++) {
				const annotation = newAnnotations[i];
				const annotationTextToServer = annotation.text.replace(/\\n/g, "%0A");
				let url = urlPath + "/api/annotationsave?admaterial=" + annotation.admaterial
					+ "&x=" + annotation.x + "&y=" + annotation.y + "&w=" + (annotation.w <= 0 ? DEFAULT_WIDTH : annotation.w) + "&h=" + (annotation.h <= 0 ? DEFAULT_HEIGHT : annotation.h)
					+ "&color=" + annotation.color + "&text=" + encodeURIComponent(annotationTextToServer).replace(/%250A/g, "%0A") + "&type=" + annotation.type + "&page=" + annotation.page;
				if (annotation.annotationId) url += "&id=" + annotation.annotationId;
				console.log("Submitting annotation (checkAnnotations 2)", annotation, url);
				if (annotation.annotationId)
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => console.log("Submitted note", response.text()))
						.catch(e => console.error("Cannot submit note", e));
				else {
					// Do not remove or comment out this line! It is used in UI tests!
					console.log("Submitting annotation x:" + annotation.x + " y:" + annotation.y);
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => response.json()
							.then(data => ({ data: data, status: response.status })).then(res => {
								console.log("Annotation submitted: " + res.status + ", " + res.data);
								const annot = document.getElementsByClassName("annotation." + this.state.annotationId)[0];
								annot.classList.add("annotation." + res.data.saved);
								annot.setAttribute("data-id", "annotation." + res.data.saved);
								annot.setAttribute("id", "annotationPost." + res.data.saved);
								annot.classList.remove("annotation." + this.state.annotationId);
								this.setState({ annotationId: res.data.saved });
								document.getElementById("annotationPost." + res.data.saved).setAttribute("data-text", annotation.text);
								this.setState({ newAnnotations: [] });
							}))
						.catch(e => {
							console.error("Cannot submit annotation", e);
							this.setState({ newAnnotations: [] });
						});
				}
			}
		}
	};

	sendToProduction = (matspec, complete, assetVisualId) => {
		if (matspec && !complete) {
			let { submittedMatspecs } = this.state;
			const matspecSubmitted = submittedMatspecs.filter(elem => elem === matspec);
			if (matspecSubmitted.length === 0)
				submittedMatspecs = submittedMatspecs.concat([matspec]);
			this.setState({ submittedMatspecs });
		}
		if (matspec && complete) {
			let { producedMatspecs } = this.state;
			const matspecProduced = producedMatspecs.filter(elem => elem === matspec);
			if (matspecProduced.length === 0)
				producedMatspecs = producedMatspecs.concat([matspec]);
			this.setState({ producedMatspecs });
		}

		let triggerSubmit = true;
		this.setState({ unsubmittedChanges: false });
		if (this.checkFrameFieldValue("assetTabFrame", "description") == 0 && this.props.loadConfig.assetRequireDescription) {
			triggerSubmit = false;
			this.setState({
				sendToProductionProgress: false,
				submitToProductionProgress: false,
				producedMatspecs: []
			});
			Modal.error({
				title: this.props.translations.forbidden,
				content: this.props.translations.descriptionEmpty,
				onOk: () => console.log("back to details"),
				onCancel: () => console.log("back to details")
			});
		}
		if (triggerSubmit) {
			this.newAssetUploaded(false);
			if (!complete) {
				this.setState({ submitToProductionProgress: true });
				this.submit(-7, true);
			} else
				this.setState({ sendToProductionProgress: true });
			if (assetVisualId) {
				const { newAnnotations, annotations } = this.state;
				const { approveAdmaterialId, assetVisualId } = this.props;
				this.unsubmittedChanges(false);
				if (newAnnotations.length === 0) {
					let adMaterialNotes = this.getAdMaterialNotes(annotations);
					if (adMaterialNotes)
						adMaterialNotes && adMaterialNotes.map(note => this.updateAnnotation(note.text.replace(" ", "%20"), note.id, approveAdmaterialId, note.color.replace("#", "x"), note.signals[0].width, note.signals[0].height, note.signals[0].x, note.signals[0].y, note.marked, assetVisualId, null));
					else {
						this.setState({
							sendToProductionProgress: false,
							submitToProductionProgress: false,
							newAssetUpload: false
						});
						handleGoBack(this.state.detailsMode);
						this.props.onOk();
					}
				} else {
					for (let i = 0; i < newAnnotations.length; i++) {
						const annotation = newAnnotations[i];
						const annotationTextToServer = annotation.text.replace(/\\n/g, "%0A");
						let url = urlPath + "/api/annotationsaveasset?asset=" + assetVisualId + "&x=" + annotation.x + "&y=" + annotation.y + "&w=" + (annotation.w <= 0 ? DEFAULT_WIDTH : annotation.w) + "&h=" + (annotation.h <= 0 ? DEFAULT_HEIGHT : annotation.h) + "&color=" + annotation.color + "&text=" + encodeURIComponent(annotationTextToServer).replace(/%250A/g, "%0A") + "&type=" + annotation.type;
						if (annotation.annotationId)
							url += "&id=" + annotation.annotationId;
						console.log("Submitting annotation (sendToProduction)", annotation, url);
						this.setState({ isProcessing: true })
						if (annotation.annotationId) {
							fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
								.then(response => console.log("Submitted annotation", response.text()))
								.catch(e => console.error("Cannot submit annotation", e));
						} else {
							// Do not remove or comment out this line! It is used in UI tests!
							console.log("Submitting annotation x:" + annotation.x + " y:" + annotation.y);
							fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
								.then(response => response.json()
									.then(data => ({ data: data, status: response.status }))
									.then(res => {
										console.log("Annotation submitted: " + res.status + ", " + res.data);
										const annot = document.getElementsByClassName("annotation." + this.state.annotationId)[0];
										annot.classList.add("annotation." + res.data.saved);
										annot.setAttribute("data-id", "annotation." + res.data.saved);
										annot.setAttribute("id", "annotationPost." + res.data.saved);
										annot.classList.remove("annotation." + this.state.annotationId);
										this.setState({ annotationId: res.data.saved });
										document.getElementById("annotationPost." + res.data.saved).setAttribute("data-text", annotation.text);
									})
								)
								.catch(e => console.error("Cannot submit annotation", e));
						}
					}
					this.setState({ isProcessing: false })
					handleGoBack(this.state.detailsMode);
				}
			}
			if (matspec) {
				fetch(urlPath + "/api/assetsubmit?complete=" + complete + "&matspec=" + matspec, { method: "POST", credentials: "include", headers: getAuthHeader() })
					.then(response => {
						//console.log("Submitted to production", response.text());
						this.setState({
							sendToProductionProgress: false,
							submitToProductionProgress: false
						});
						handleGoBack(this.state.detailsMode);
						this.props.onOk();
					})
					.catch(e => {
						console.error("Cannot submit to production", e);
						this.setState({
							sendToProductionProgress: false,
							submitToProductionProgress: false
						});
						this.props.onOk();
					});
			} else
				console.error("Cannot submit asset to no matspec");
		} //closeModal Conditional
	};
	onTermsChange = e => {
		this.setState({
			correctTerms: !e.target.checked,
			approveTerms: !e.target.checked,
			approveWithChangesTerms: !e.target.checked
		});
	};
	deleteVisual = (admaterial, matspecId, assetVisualId) => {
		if (assetVisualId) {
			const visualAssetsIds = [];
			visualAssetsIds.push(assetVisualId);
			this.discardAssets(visualAssetsIds);
		}
	};

	discardAssets = assetIds => {
		//PERFORMANCE use a CSV for the asset ids, so it is a single call to the server
		for (let i = 0; i < assetIds.length; i++) {
			fetch(urlPath + "/api/assetdelete?asset=" + assetIds[i], { method: "POST", credentials: "include", headers: getAuthHeader() })
				.then(response => {
					//console.log("Assets discard", response.text());
					const { editableView, specId, currentStatusCode } = this.props;
					this.props.previewClick(editableView, null, specId, "[]", true, currentStatusCode);
				})
				.catch(e => console.error("Cannot discard asset", e));
		}
	};
	reloadReport = asset => {
		const { editableView, approveAdmaterialId, specId } = this.props;
		this.setState({ showProductionAdButtons: true });
		this.props.previewClick(editableView, approveAdmaterialId, specId, "[]", asset, null, null, true);
	};

	unsubmittedChanges = val => {
		this.setState({ unsubmittedChanges: val });
	};

	updateAnnotation = (text, annotationId, admaterial, color, width, height, positionX, positionY, reviewed, assetVisualId, status) => {
		let url = admaterial < 0 && assetVisualId ?
			urlPath + "/api/annotationsaveasset?asset=" + assetVisualId
			+ "&x=" + positionX + "&y=" + positionY + "&w=10&h=10" :
			urlPath + "/api/annotationsave?admaterial=" + admaterial
			+ "&x=" + positionX + "&y=" + positionY + "&w=" + (width <= 0 ? DEFAULT_WIDTH : width) + "&h=" + (height <= 0 ? DEFAULT_HEIGHT : height);
		url += "&text=" + encodeURIComponent(text.replace(/\n/g, "%0A")) + "&reviewed=" + reviewed + "&color=" + color;
		if (annotationId && annotationId > 0) url += "&id=" + annotationId;
		if (status) url += "&status=" + status;
		if (annotationId) {
			fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
				.then(response => setTimeout(() => {
					if (this.state.visible) this.props.onOk();
				}, 500))
				.catch(e => console.error("Cannot submit annotation", e));
		}
	};

	submitOnly = async status => {
		this.setState({ submitOnlyProgress: true, isProcessing: true })
		const { newAnnotations, annotations } = this.state;
		const { approveAdmaterialId, assetVisualId } = this.props;
		this.unsubmittedChanges(false);
		if (newAnnotations.length === 0) {
			const adMaterialNotes = this.getAdMaterialNotes(annotations);
			adMaterialNotes && adMaterialNotes.map(note => this.updateAnnotation(note.text.replace(" ", "%20"), note.id, approveAdmaterialId, note.color.replace("#", "x"), note.signals[0].width, note.signals[0].height, note.signals[0].x, note.signals[0].y, note.marked, assetVisualId, status));
		} else {
			for (let i = 0; i < newAnnotations.length; i++) {
				const annotation = newAnnotations[i];
				const url = urlPath + "/api/annotationsave?admaterial=" + annotation.admaterial
					+ "&x=" + annotation.x + "&y=" + annotation.y + "&w=" + (annotation.w <= 0 ? DEFAULT_WIDTH : annotation.w) + "&h=" + (annotation.h <= 0 ? DEFAULT_HEIGHT : annotation.h)
					+ "&color=" + annotation.color + "&text=" + encodeURIComponent(annotation.text.replace(/\\n/g, "%0A")).replace(/%250A/g, "%0A") + "&type=" + annotation.type + "&page=" + annotation.page
					+ (annotation.annotationId && annotation.annotationId > 0 ? "&id=" + annotation.annotationId : "")
					+ (status && i === newAnnotations.length - 1 ? "&status=" + status : "")
				console.log("Submitting annotation (submitonly)", annotation, url);
				if (annotation.annotationId) {
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => this.setState({
							sendToProductionProgress: false,
							submitToProductionProgress: false,
							submitOnlyProgress: false
						}))
						.catch(e => {
							console.error("Cannot submit note", e);
							this.setState({
								sendToProductionProgress: false,
								submitToProductionProgress: false
							});
						});
				} else {
					// Do not remove or comment out this line! It is used in UI tests!
					console.log("Submitting annotation x:" + annotation.x + " y:" + annotation.y);
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => response.json()
							.then(data => ({ data: data, status: response.status }))
							.then(res => {
								console.log("Annotation submitted: " + res.status + ", " + res.data);
								const annot = document.getElementsByClassName("annotation." + this.state.annotationId)[0];
								if (annot) {
									annot.classList.add("annotation." + res.data.saved);
									annot.setAttribute("data-id", "annotation." + res.data.saved);
									annot.setAttribute("id", "annotationPost." + res.data.saved);
									annot.classList.remove("annotation." + this.state.annotationId);
								}
								this.setState({ annotationId: res.data.saved });
								const annotPost = document.getElementById("annotationPost." + res.data.saved);
								if (annotPost)
									annotPost.setAttribute("data-text", annotation.text);
								this.setState({ newAnnotations: [] });
							}))
						.catch(e => {
							console.error("Cannot submit annotation", e);
							this.setState({ newAnnotations: [] });
						});
				}
			}
			handleGoBack(this.state.detailsMode);
			this.setState({ submitOnlyProgress: false, isProcessing: false })
			this.props.onOk();
		}
	}

	setNewAssets = (admaterialId, newAssetIds, matspecid) => {
		this.newAssetUploaded(true);
		if (admaterialId < 0) admaterialId = null;
		this.props.assetToMaterial(admaterialId, matspecid, newAssetIds, true);
	};
	submitMatspecNote = async () => {
		this.setState({ isProcessing: true });
		await changeStatus(this.state.matspecId ? this.state.matspecId : this.props.specId, 536);
		this.setState({ isProcessing: false })
		await this.props.onOk();
	};

	submit = async (status, asset) => {
		this.setState({ submitProgress: true, isProcessing: true })
		const { newAnnotations, annotations } = this.state;
		const { approveAdmaterialId, assetVisualId } = this.props;
		this.unsubmittedChanges(false);
		if (newAnnotations.length === 0) {
			let adMaterialNotes = this.getAdMaterialNotes(annotations);
			if (adMaterialNotes) {
				adMaterialNotes.map(note => this.updateAnnotation(note.text.replace(" ", "%20"), note.id, approveAdmaterialId, note.color.replace("#", "x"), note.signals[0].width, note.signals[0].height, note.signals[0].x, note.signals[0].y, note.marked, assetVisualId, status));
			} else {
				this.setState({
					sendToProductionProgress: false,
					submitToProductionProgress: false,
					newAssetUpload: false,
					submitProgress: false
				});
				this.props.onOk();
			}
		} else if (!asset) {
			for (let i = 0; i < newAnnotations.length; i++) {
				const annotation = newAnnotations[i];
				const url = urlPath + "/api/annotationsave?admaterial=" + annotation.admaterial
					+ "&x=" + annotation.x + "&y=" + annotation.y + "&w=" + (annotation.w <= 0 ? DEFAULT_WIDTH : annotation.w) + "&h=" + (annotation.h <= 0 ? DEFAULT_HEIGHT : annotation.h)
					+ "&color=" + annotation.color + "&text=" + encodeURIComponent(annotation.text.replace(/\\n/g, "%0A")).replace(/%250A/g, "%0A") + "&type=" + annotation.type + "&page=" + annotation.page
					+ (annotation.annotationId ? "&id=" + annotation.annotationId : "")
					+ (i === newAnnotations.length - 1 ? "&status=" + status : "");
				console.log("Submitting annotation (submit)", annotation, url);
				if (annotation.annotationId)
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => console.log("Submitted annotation", response.text()))
						.catch(e => console.error("Cannot submit annotation", e));
				else {
					// Do not remove or comment out this line! It is used in UI tests!
					console.log("Submitting annotation x:" + annotation.x + " y:" + annotation.y);
					await fetch(url, { method: "POST", credentials: "include", headers: getAuthHeader() })
						.then(response => response.json()
							.then(data => ({ data: data, status: response.status }))
							.then(res => {
								console.log("Annotation submitted: " + res.status + ", " + res.data);
								const annot = document.getElementsByClassName("annotation." + this.state.annotationId)[0];
								if (typeof annot !== "undefined") {
									annot.classList.add("annotation." + res.data.saved);
									annot.setAttribute("data-id", "annotation." + res.data.saved);
									annot.setAttribute("id", "annotationPost." + res.data.saved);
									annot.classList.remove("annotation." + this.state.annotationId);
								}
								this.setState({ annotationId: res.data.saved });
								const annotPost = document.getElementById("annotationPost." + res.data.saved);
								if (annotPost && typeof annotPost !== "undefined")
									annotPost.setAttribute("data-text", annotation.text);
							}))
						.catch(e => console.error("Cannot submit annotation", e));
				}
			}
			handleGoBack(this.state.detailsMode);
			this.setState({ submitProgress: false, isProcessing: false })
			this.props.onOk();
		}
	};

	admaterialUpdate = (e, admaterial, field, value) => {
		if (!admaterial || admaterial < 1)
			console.error("Wrong AdMaterial." + admaterial);
		else if (this.checkValidUrl(value))
			fetch(urlPath + "/api/admaterialupdate?admaterial=" + admaterial + "&" + field + "=" + encodeURIComponent(value),
				{ method: "PUT", credentials: "include", headers: getAuthHeader() })
				.then(response => response.json())
				.then(data => console.log("AdMaterial." + admaterial + " update:", field + "=" + value, data))
				.catch(e => console.error("Cannot update material", e));
	};
	checkValidUrl = url => {
		const pattern = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
		if (!pattern.test(url)) {
			document.getElementById("validPopUpUrlMsg").classList.remove("d-none");
			document.getElementById("validPopUpUrlMsg").classList.add("error-msg");
			console.log("Please enter a valid URL.");
			return false;
		} else {
			document.getElementById("validPopUpUrlMsg").classList.add("d-none");
			document.getElementById("validPopUpUrlMsg").classList.remove("error-msg");
			return true;
		}
	};

	checkMaterialUrls = (matspec, admaterial, status) => {
		this.setState({ approveProgress: true, isProcessing: true });
		if (this.props.printed)
			this.approve(matspec, admaterial, status); else {
			fetch(urlPath + "/api/loadadmaterial?admaterial=" + admaterial + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone,
				{ credentials: "include", headers: getAuthHeader() })
				.then(response => response.json())
				.then(data => {
					if (data.userurls && data.userurls.length > 0)
						this.approve(matspec, admaterial, status);
					else
						this.shouldApprove(matspec, admaterial, status);
				})
				.catch(e => {
					console.error("Cannot load userUrls!", e);
					this.shouldApprove(matspec, admaterial, status);
				})
				.finally(() => {
					this.setState({ isProcessing: false });
				});
		}
	};

	shouldApprove = (matspec, admaterial, status) => {
		const { loadConfig, preflightReport, internal } = this.props;
		this.setState({
			approveProgress: false,
			approveWithChangesProgress: false
		});
		let report = preflightReport;
		let urlMandatoryForFileTypes = internal
			? loadConfig["web.uploadadmaterial.internal.urlmandatoryforfiletypes"]
			: loadConfig["web.uploadadmaterial.customer.urlmandatoryforfiletypes"];
		let urlMandatoryForFileTypesMatch = false;
		if (typeof report === "string") {
			report = JSON.parse(report);
		}
		const hasFile = report.files && report.files.length === 1 && report.files[0];
		if (hasFile)
			for (let i = 0; i < urlMandatoryForFileTypes.length; i++) {
				if (urlMandatoryForFileTypes[i].toLowerCase() === report.files[0].format.toLowerCase()) {
					urlMandatoryForFileTypesMatch = true;
					break;
				}
			}
		if (loadConfig.adMaterialRequireUrl || (hasFile && urlMandatoryForFileTypesMatch)) {
			if (hasFile) {
				Modal.error({
					title: this.props.translations.unsubmittedUrl,
					footer: null,
					onOk: () => console.log("back to details"),
					content: (
						<span>
							<p className="d-none" data-translationkey="unsubmittedUrl">
								{this.props.translations.unsubmittedUrl}
							</p>
							<label className="d-none" data-translationkey="placeUrl">
								{this.props.translations.placeUrl}
							</label>
							<Input
								data-translationkey="placeUrl"
								placeholder={this.props.translations.placeUrl}
								prefix={<Icon type="link" style={{ color: "rgba(0,0,0,.25)" }} />}
								type="url"
								onChange={e => this.admaterialUpdate(e, admaterial, "userurl", e.target.value)}
							/>
							<span className="d-none"
								id="validPopUpUrlMsg"
								data-translationkey="invalidUrl">
								{this.props.translations.invalidUrl}
							</span>
						</span>
					)
				});
				return false;
			} else
				this.approve(matspec, admaterial, status);
		} else
			this.approve(matspec, admaterial, status);
	};

	approve = (matspec, admaterial, status) => {
		this.setState({ approveProgress: true });
		fetch(urlPath + "/api/admaterialcommit?approve_correct=true&matspec=" + matspec + "&admaterial=" + admaterial,
			{ method: "POST", credentials: "include", headers: getAuthHeader() })
			.then(response => {
				//console.log("Commited admaterial", response.text());
				this.setState({ approveProgress: false });
				handleGoBack(this.state.detailsMode);
				this.props.onOk();
			})
			.catch(e => {
				console.error("Cannot commit", e);
				this.setState({ approveProgress: false });
				this.props.onOk();
			});
	};

	approveWithChanges = (matspec, admaterial, status) => {
		this.setState({ approveWithChangesProgress: true });
		this.submitOnly(status);
	};

	getStatusCode(matspec, admaterialId, matspecId) {
		if (matspecId && admaterialId) {
			for (let i = 0; i < matspec.matspecs.length; i++) {
				if (matspec.matspecs[i].id === matspecId) {
					for (let j = 0; j < matspec.matspecs[i].admaterial.length; j++) {
						if (matspec.matspecs[i].admaterial[j].id === admaterialId)
							return matspec.matspecs[i].admaterial[j].status.code;
					}
				}
			}
		}
		if (this.props.currentStatusCode)
			return this.props.currentStatusCode;
		return 522;
	}

	assetToMaterial = (admaterial, matspecid, admaterialid) => {
		this.props.assetToMaterial(admaterial, matspecid, admaterialid);
	};

	newAssetNote = assetId => {
		this.setState({ newAssetNoteId: assetId });
	};
	newAnnotationFlag = val => {
		this.setState({ newAnnotationFlag: val });
	};

	onOk = () => {
		this.setState({ activeTabReport: null });
		if (this.state.newAnnotations.length > 0 && this.props.reviewButtonClicked) {
			Modal.error({
				title: this.props.translations.forbidden,
				content: this.props.translations.unsubmittedAnnotations,
				onOk: () => console.log("back to details"),
				onCancel: () => console.log("back to details")
			});
			return null;
		}
		if (this.props.reviewButtonClicked &&
			this.props.loadConfig["web.details.unsubmittedchangesalert"] &&
			(this.state.unsubmittedChanges || this.props.unsubmittedChangesValue)
		) {
			const modal = Modal.warning({
				className: "popup-modal unsubmittedChanges-modal",
				title: this.props.translations.warning,
				onOk: () => console.log("back to details"),
				onCancel: () => console.log("back to details"),
				content: (
					<span data-translationkey="unsubmittedChanges">
						{this.props.translations.unsubmittedChanges}
						<footer className="popup-footer">
							<Button data-translationkey="cancel" type="secondary" onClick={() => modal.destroy()}>
								{this.props.translations.cancel}
							</Button>
							<Button data-translationkey="close"
								type="primary"
								onClick={() => {
									this.unsubmittedChanges(false);
									modal.destroy();
									this.props.onOk();
								}}>
								{this.props.translations.close}
							</Button>
						</footer>
					</span>
				)
			});
			return null;
		}
		/*if (!this.props.reviewButtonClicked) {
	  this.props.onOk();
	}*/
		if (!this.state.unsubmittedChanges && !this.props.unsubmittedChangesValue && this.state.newAnnotations.length < 1) {
			this.props.onOk();
			return null;
		}
		this.props.onOk();
	};
	togglePanelView = e => {
		const target = e.target;
		const expand = target.getAttribute("data-expand");
		if (expand !== "true") {
			target.setAttribute("data-expand", true);
			target.setAttribute("data-translation", "collapse");
			target.closest(".panel-container").classList.add("panel-container-expanded");
			target.innerHTML = this.props.translations.collapse;
		} else {
			target.setAttribute("data-expand", false);
			target.setAttribute("data-translation", "expand");
			target.closest(".panel-container").classList.remove("panel-container-expanded");
			target.innerHTML = this.props.translations.expand;
		}
	};
	showNextPage = pageCount => {
		const previewImage = document.getElementById("previewImage");
		this.setState({ pageCount: pageCount, preloadingMask: true });
		if (previewImage) {
			let report = typeof this.props.preflightReport === "object" ? this.props.preflightReport : JSON.parse(this.props.preflightReport);
			previewImage.src = report.bigpreviewArray[pageCount];
		}
	};

	noteSaved = () => {
		console.log("note saved");
		this.setState({ newNoteSaved: true });
	};

	showPrevPage = pageCount => {
		const previewImage = document.getElementById("previewImage");
		this.setState({ pageCount: pageCount, preloadingMask: true });
		if (previewImage) {
			let report = typeof this.props.preflightReport === "object" ? this.props.preflightReport : JSON.parse(this.props.preflightReport);
			previewImage.src = report.bigpreviewArray[pageCount];
		}
	};
	tabClicked = tab => {
		this.setState({ activeTabReport: tab });
		const annotationCanvas = document.getElementById("annotationCanvas");
		if (tab === "5" && annotationCanvas)
			annotationCanvas.classList.add("visible");
	};

	getCurrentMaterial = (matspec, matspecId, admaterialId) => {
		if (matspecId && admaterialId) {
			for (let i = 0; i < matspec.matspecs.length; i++) {
				if (matspec.matspecs[i].id === matspecId) {
					for (let j = 0; j < matspec.matspecs[i].admaterial.length; j++) {
						if (matspec.matspecs[i].admaterial[j].id === admaterialId)
							return matspec.matspecs[i].admaterial[j];
					}
				}
			}
		}
		return null;
	};
	getAdMaterialNotes = annotations => {
		const { approveAdmaterialId } = this.props;
		if (annotations && typeof annotations === []) {
			const admaterialNotes = approveAdmaterialId && annotations && annotations.filter(annotation => annotation.parent.includes(approveAdmaterialId.toString()));
			if (admaterialNotes && admaterialNotes.length > 0) return admaterialNotes;
			//if (assetNotes && assetNotes.length > 0) return assetNotes;
			return null;
		}
	};
	newAssetUploaded = val => {
		this.setState({ newAssetUpload: val });
	};
	handlePartyChange = value => {
		this.setState({ newPartyTagValue: value, partyTagModified: true });
	};
	handleNewPartyTag = async () => {
		const { newPartyTagValue } = this.state;
		this.setState({ partyProcessing: true, isProcessing: true });
		const data = await processPartyTag(newPartyTagValue, this.props.specId, this.props.approveAdmaterialId, null);
		this.setState({ partyProcessing: false, isProcessing: false });
	};

	render() {
		const { currentMaterialIndex, currentMaterialsLength, showCarousel } = this.state;
		const editableView = this.props.editableView;
		const editableParam = "?editable=" + editableView;
		const renderButtons = [];
		let buttons = null;
		let imageAd = null;
		let audioAd = null;
		let data = this.props.preflightReport;
		let statusCode = this.getStatusCode(this.props.matspec, this.props.approveAdmaterialId, this.props.specId);
		//const currentAdMaterial = this.getCurrentMaterial(this.props.matspec, this.props.specId, this.props.approveAdmaterialId);
		if (data && typeof data !== "object") data = JSON.parse(data);
		//const fileList = [];
		if (data && data.files && data.files[0])
			imageAd =
				data.files[0].format === "jpg" ||
				data.files[0].format === "jpeg" ||
				data.files[0].format === "JPG" ||
				data.files[0].format === "JPEG" ||
				data.files[0].format === "png" ||
				data.files[0].format === "PNG" ||
				data.files[0].format === "tiff" ||
				data.files[0].format === "psd";
		if (data && data.files && data.files[0])
			audioAd = data.files[0].format === "mp3" || data.files[0].format === "MP3";
		let videoAd = data && data.originalUrl && data.originalUrl.toLowerCase().endsWith(".mp4");
		/*if (data && data.files)
	  for (let i = 0; i < data.files.length; i++)
		fileList.push({
		  fileName: data.files[i].serverfilename,
		  fileSize: data.files[i].size,
		  fileWidth: data.files[i].width,
		  fileHeight: data.files[i].height,
		  fileUrl: data.files[i].url,
		  filePreview: data.previewUrl,
		  fileDestinationfile: data.destinationfile,
		  fileModificationDate: data.modificationDate
		});*/
		if (new URL(window.location.href).href.includes("mode=details"))
			setTimeout(() => {
				if (document.getElementById("ixReport"))
					document.getElementById("ixReport").classList.add("detailsMode");
			}, 50);
		if (data && data.buttons && editableView) {
			buttons = data.buttons;
			for (let i = 0; i < buttons.visible.length; i++) {
				switch (buttons.visible[i]) {
					case "RESUBMIT":
						renderButtons.push(
							<Button
								size="default"
								onClick={this.handleResubmit}
								id="ad-resubmit"
								type="primary"
								disabled={this.state.isProcessing}
								data-translationkey="resubmit">
								{this.props.translations.resubmit}
							</Button>
						);
						break;
					case "CORRECT":
						renderButtons.push(
							<Button
								size="default"
								onClick={this.handleCorrect}
								id="ad-correct"
								type="primary"
								data-translationkey="correct"
								disabled={this.state.correctTerms}>
								{this.props.translations.correct ? this.props.translations.correct : "Correct"}
							</Button>
						);
						break;
					default:
						break;
				}
			}
		}
		const { changesButtons, approveAdmaterialId, specId, assetView, translations, assetVisualId } = this.props;

		const approve = changesButtons.APPROVE;
		const approveWithChanges = changesButtons.APPROVEWITHCHANGES;
		const submit = changesButtons.SUBMIT;
		const submitOnly = changesButtons.SUBMITONLY;
		const showOkButton =
			(data && !data.buttons && (this.props.internal || (this.props.loadConfig && this.props.loadConfig["web.details.customer.okbutton"] && !approveWithChanges && !approve))) ||
			(assetView && (this.props.loadConfig && this.props.loadConfig["web.details.customer.okbutton"]));

		if (this.state.partyTagModified) {
			renderButtons.push(
				<Button
					data-translationkey="resubmit"
					onClick={this.handleNewPartyTag}
					type="primary"
					disabled={this.state.isProcessing}
					loading={this.state.partyProcessing}>
					{translations.resubmit}
				</Button>
			);
		}
		if (this.state.detailsMode) {
			let browserUrl = new URL(window.location.href);
			browserUrl = browserUrl.href;
			let backUrl = browserUrl.replace("mode=details", "");
			if (this.props.tabbedView) browserUrl = browserUrl + "&tabbedView";
			renderButtons.push(
				<Button
					data-translationkey="back"
					onClick={() => (window.location.href = backUrl)}
					type="primary">
					{translations.back}
				</Button>
			);
		} else {
			renderButtons.push(
				<Button
					disabled={this.state.newAnnotations.length > 0 || this.state.isProcessing}
					size="default"
					onClick={() => this.onOk()}
					className={!showOkButton ? "d-none" : ""}
					id="okDetailsButton"
					type="primary"
					data-translationkey="ok">
					{this.props.translations ? this.props.translations.ok : "Ok"}
				</Button>
			);
		}
		let displaySubmit = this.state.newAnnotations.length > 0 || this.getAdMaterialNotes(this.state.annotations);
		let newNoteSaved = this.state.newNoteSaved;
		if (newNoteSaved && (rol ? rol.toUpperCase() === 'CLIENT' || rol.toUpperCase() === 'CLIENT' : true) && (statusCode == "-7" 
		|| statusCode == "522"
		|| statusCode == "518"
		|| statusCode == "-4"
		|| statusCode == "527"
		|| statusCode == "552"
		|| statusCode == "580"
		|| statusCode == "549"
		|| statusCode == "582"
		|| statusCode == "550"
		|| statusCode == "581")) {
			renderButtons.push(
				<Button
					onClick={() => this.submitMatspecNote(submit[0].code)}
					size="default"
					id="ad-submit-matspec-note"
					key="ad-submit-matspec-note"
					type="primary"
					disabled={this.state.isProcessing}
					data-translationkey="submitAd">
					{translations.submitAd}
				</Button>
			);
		}
		if (editableView && ((changesButtons && !assetView) || (changesButtons && !assetView && statusCode === 518))) {
			if (submitOnly) {
				renderButtons.push(
					<Button
						loading={this.state.submitOnlyProgress}
						disabled={this.state.submitOnlyProgress || this.state.isProcessing}
						className={!displaySubmit && "d-none"}
						onClick={() => this.submitOnly()}
						size="default"
						id="ad-submit-only"
						key="ad-submit-only"
						type="primary"
						data-translationkey="submitOnly">
						{translations.submitOnly}
					</Button>
				);
			}
			if (submit) {
				renderButtons.push(
					<Button
						loading={this.state.submitProgress}
						disabled={this.state.submitProgress || this.state.isProcessing}
						className={!displaySubmit && "d-none"}
						onClick={() => this.submit(submit[0].code)}
						size="default"
						id="ad-submit"
						key="ad-submit"
						type="primary"
						data-translationkey="submitAd">
						{translations.submitAd}
					</Button>
				);
			}
			if (!this.state.partyTagModified && approveWithChanges) {
				renderButtons.push(
					<Button
						className={(!displaySubmit || (this.state.showTerms && this.state.approveWithChangesTerms)) && "d-none"}
						onClick={() => this.approveWithChanges(specId, approveAdmaterialId, approveWithChanges.code)}
						loading={this.state.approveWithChangesProgress}
						size="default"
						id="ad-approve-changes"
						key="ad-approve-changes"
						type="primary"
						data-translationkey="approveWithChanges"
						disabled={this.state.approveWithChangesTerms || this.state.approveWithChangesProgress || this.isProcessing}>
						{translations.approveWithChanges}
					</Button>
				);
			}
			//			if (!this.state.partyTagModified && (approve || this.state.showApproveTerms) && this.props.hasMaterial) {
			if (!this.state.partyTagModified && (approve) && this.props.hasMaterial) {
				const approveButtonToDiscard = document.getElementById("ad-approve");
				if (approveButtonToDiscard)
					approveButtonToDiscard.classList.add("d-none");
				renderButtons.push(
					<Button
						loading={this.state.approveProgress}
						onClick={() => this.checkMaterialUrls(specId, approveAdmaterialId)}
						size="default"
						id="ad-approve-only"
						key="ad-approve-only"
						type="primary"
						data-translationkey="approve"
						disabled={this.state.approveTerms || this.state.approveProgress || this.isProcessing}>
						{translations.approve}
					</Button>
				);
			}
		}
		const { submittedMatspecs, producedMatspecs } = this.state;
		const matspecSubmitted = submittedMatspecs.filter(elem => elem === specId).length > 0;
		const matspecProduced = producedMatspecs.filter(elem => elem === specId).length > 0;

		const hideSendToProduction = statusCode != "-7" && statusCode != "570" && (
			matspecProduced || !matspecSubmitted &&
			(!this.state.newAssetUpload &&
				this.props.newAssetIds &&
				this.props.newAssetIds === "[]" &&
				!this.state.hasDescription &&
				!this.props.hasVisual &&
				!this.getAdMaterialNotes(this.state.annotations) &&
				this.state.newAnnotations &&
				this.state.newAnnotations.length === 0));
		const rol = document.getElementsByTagName("body")[0].getAttribute("data-role");
		if ((rol.toUpperCase() === 'CLIENT' || rol.toUpperCase() === 'CLIENT') && (statusCode == "-7"
		|| statusCode == "522"
		|| statusCode == "-4"
		|| statusCode == "527"
		|| statusCode == "552"
		|| statusCode == "580"
		|| statusCode == "549"
		|| statusCode == "582"
		|| statusCode == "550"
		|| statusCode == "531"
		|| statusCode == "578"
		|| statusCode == "1102"
		|| statusCode == "1223"
		|| statusCode == "581")) {
			renderButtons.push(
				<Button
					loading={this.state.submitToProductionProgress}
					disabled={this.state.submitToProductionProgress || this.state.isProcessing}
					onClick={() => this.sendToProduction(specId, false, this.props.assetVisualId)}
					className={!(!hideSendToProduction || (this.state.showSubmitButton && rol === 'CLIENT')) && "d-none"}
					size="default"
					id="ad-submit-assets"
					key="ad-submit-assets"
					type="primary"
					data-translationkey="submitAssets">
					{this.props.translations.submitAssets}
				</Button>
			);
			renderButtons.push(
				<Button
					className={!(!hideSendToProduction || (this.state.showSubmitButton && rol === 'CLIENT')) && "d-none"}
					loading={this.state.sendToProductionProgress}
					disabled={this.state.sendToProductionProgress || this.state.isProcessing}
					onClick={() => this.sendToProduction(specId, true, assetVisualId)}
					size="default"
					id="ad-send-production"
					key="ad-send-production"
					type="primary"
					data-translationkey="sendToProduction">
					{this.props.translations.sendToProduction}
				</Button>
			);
		} else {
			if (((devMode || (editableView && (this.props.assetView || (this.state.isOnAssetView && (rol.toUpperCase() === 'CLIENT' || rol.toUpperCase() === 'CLIENT'))) && (this.props.showProductionAdButtons || this.state.newAssetUpload || displaySubmit)))
			|| (this.state.showSubmitButton && (rol.toUpperCase() === 'CLIENT' || rol.toUpperCase() === 'CLIENT'))) && (
				statusCode == "-7" 
				|| statusCode == "522"
				|| statusCode == "-4"
				|| statusCode == "527"
				|| statusCode == "552"
				|| statusCode == "580"
				|| statusCode == "549"
				|| statusCode == "582"
				|| statusCode == "550"
				|| statusCode == "531"
				|| statusCode == "578"
				|| statusCode == "1102"
				|| statusCode == "1223"
				|| statusCode == "581"
			)) {
				renderButtons.push(
					<Button
						className={!(!hideSendToProduction || (this.state.showSubmitButton && rol === 'CLIENT')) && "d-none"}
						loading={this.state.submitToProductionProgress}
						disabled={this.state.isProcessing}
						onClick={() => this.sendToProduction(specId, false, this.props.assetVisualId)}
						size="default"
						id="ad-submit-assets"
						key="ad-submit-assets"
						type="primary"
						data-translationkey="submitAssets">
						{this.props.translations.submitAssets}
					</Button>
				);
				renderButtons.push(
					<Button
						className={!(!hideSendToProduction || (this.state.showSubmitButton && rol === 'CLIENT')) && "d-none"}
						loading={this.state.sendToProductionProgress}
						disabled={this.state.isProcessing}
						onClick={() => this.sendToProduction(specId, true, assetVisualId)}
						size="default"
						id="ad-send-production"
						key="ad-send-production"
						type="primary"
						data-translationkey="sendToProduction">
						{this.props.translations.sendToProduction}
					</Button>
				);
			}
		}

		const validationText = (
			<p className={data && data.haserrors ? "tomato" : ""}>
				{this.props.translations.validation}
			</p>
		);
		const { Content, Footer, Sider } = Layout;
		const TabPane = Tabs.TabPane;
		const role = document.getElementsByTagName("body")[0].getAttribute("data-role");
		const isGif = data && data.files && data.files[0] && data.files[0].format && data.files[0].format.toLowerCase() === "gif";
		if (this.props.visible) {
			let browserUrl = new URL(window.location.href).href;
			const backUrl = browserUrl.replace("mode=details", "");
			return (
				<div>
					<Modal
						className="report-modal ix-report"
						title={this.props.modalTitle}
						onOk={this.onOk}
						onReturn={this.props.onCancel}
						onCancel={this.onOk}
						closable={false}
						visible={this.props.visible}
						width={9999}
						footer={null}
					>
						<Button id="closeDetailsButton"
							size="small"
							onClick={() => !this.state.detailsMode ? this.onOk() : (window.location.href = backUrl)}>
							<Icon type="close" />
						</Button>
						<div id="ixReport" data-video={data && data.originalUrl && data.originalUrl.toLowerCase().endsWith(".mp4")}>
							{showCarousel && (
								<div id="creativeCarouselCounter">
									{translations.viewingCreative} {currentMaterialIndex + 1}{" "}
									{translations.of} {currentMaterialsLength}
								</div>
							)}
							<Header
								orderno={this.props.orderno}
								matspecname={this.props.matspec.matspecs.filter(item => item.id === this.props.specId)[0].name}
								translations={this.props.translations}
								clickHelp={this.props.clickHelp}
								fieldConfig={this.props.fieldConfig}
								matspec={this.props.matspec}
								language={this.props.language}
								langCode={this.props.handleLangCode}
								currentMaterialIndex={this.state.currentMaterialIndex}
							/>
							<Layout>
								<Sider
									collapsed={this.state.collapsed}
									onCollapse={this.onCollapse}
									style={{ overflow: "auto" }}
								>
									{((data &&
										(data.xmllogUrl || data.fatalError) &&
										this.props.defaultActiveTabReport == "1") ||
										this.props.defaultActiveTabReport != "1" ||
										(data && data.error)) && (
											<Tabs
												defaultActiveKey={this.state.activeTabReport || this.props.defaultActiveTabReport}
												onChange={() => this.setExpandablePanels()}
												onTabClick={tab => this.tabClicked(tab)}
											>
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.validation"] &&
													!this.props.assetView &&
													this.state.showReport && data !== null &&
													(data.xmllogUrl || data.fatalError) && (
														<TabPane tab={validationText} key="1">
															{data.admaterialid && data.admaterialid > 0 && data.destinationfile && (
																<div
																	className={data && data.haserrors ? "ix-report ix-report-result" : "ix-report ix-report-result ix-report-valid"}>
																	<Icon
																		className={data && data.haserrors ? "result-icon invalid" : "result-icon valid"}
																		type={data && data.haserrors ? "close-circle" : "check-circle"}
																	/>
																	<span
																		data-translationkey="preflightErrorMessage preflightValidMessage"
																		className={data && data.haserrors ? "report-header-subtitle invalid" : "report-header-subtitle valid"}
																	>
																		{data && data.haserrors ? this.props.translations.preflightErrorMessage : this.props.translations.preflightValidMessage}
																	</span>
																</div>
															)}

															<Collapse defaultActiveKey={["1", "2"]}>
																{data && (
																	<Panel header={this.props.translations.report} key="1">
																		<div className="panel-container">
																			<Button
																				size="small"
																				onClick={() => this.handleOpenReport(data.htmllogUrl ? data.htmllogUrl : data.pdflogUrl ? data.pdflogUrl : "")}
																				id="ad-open-report-pdf"
																				className={data.htmllogUrl || data.pdflogUrl ? "ix-pdfreport-button" : "d-none"}
																				type="default"
																			>
																				<span data-translationkey="fullReport">
																					{this.props.translations.fullReport}
																				</span>
																				<Icon type="profile" />
																			</Button>
																			{data.xmllogUrl ? (
																				<iframe
																					id="reportIframe"
																					title="reportIframe"
																					onLoad={() => this.reportIframeLoaded("reportIframe")}
																					className="report-iframe"
																					src={this.createSrcPath(data)}
																				/>
																			) : data.fatalError ? (
																				<span data-translationkey="noReport" className="d-none tomato">
																					{data.fatalError}
																				</span>
																			) : (
																						<span data-translationkey="noReport" className="font-normal font-italic">
																							{this.props.translations.noReport}
																						</span>
																					)}
																			<footer>
																				<a data-translationkey="expand"
																					data-expand={false}
																					onClick={e => this.togglePanelView(e)}
																					href="#">
																					{this.props.translations.expand}
																				</a>
																				<Icon type="down" className="expand-icon" />
																			</footer>
																		</div>
																	</Panel>
																)}
																<Panel header={data && data.matspecname ? this.props.translations.matspec + ": " + data.matspecname : "N/A"} key="2">
																	<div data-translationkey="preflightError preflightValid"
																		className={data && data.haserrors ? "ix-report-status" : "ix-report-status ix-report-valid"}
																	>
																		{data && data.haserrors
																			? this.props.translations.preflightError
																			: this.props.translations.preflightValid}
																	</div>
																	<iframe id="orderIframe"
																		title="orderIframe"
																		onLoad={() => this.reportIframeLoaded("orderIframe")}
																		style={{ border: "none" }}
																		src={this.createValidPath(this.state.reportFrame, editableParam)} />
																</Panel>
															</Collapse>
														</TabPane>
													)}
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.info"] &&
													(role !== "CLIENT" ||
														(this.state.showInfo || devMode)) && (
														<TabPane tab={this.props.translations.infoTab} key="2">
															<div className="info-tab" style={{ border: "none" }}>
																<Collapse defaultActiveKey={["1", "2"]}>
																	{!this.props.printed &&
																		this.props.loadConfig && this.props.loadConfig["web.campaign.showpartyoninfotab"] && (
																			<Panel header={this.props.translations.partyTag} key="1">
																				<div className="panel-container" style={{ minHeight: "425px" }}>
																					<PartyInfo
																						loadConfig={this.props.loadConfig}
																						showPartytagTextarea={true}
																						showSGCode={true}
																						id={this.props.approveAdmaterialId}
																						translations={this.props.translations}
																						internal={this.props.internal}
																						specId={this.props.specId}
																						handlePartyChange={this.handlePartyChange}
																					/>
																					<footer>
																						<a data-translationkey="expand"
																							data-expand={false}
																							onClick={e => this.togglePanelView(e)}
																							href="#">
																							{this.props.translations.expand}
																						</a>
																						<Icon type="down" className="expand-icon" />
																					</footer>
																				</div>
																			</Panel>
																		)}
																	<Panel header={this.props.translations.infoTab} key="2">
																		<div className={this.props.loadConfig && this.props.loadConfig["web.campaign.showpartyoninfotab"]
																			? "panel-container"
																			: "panel-container panel-container-expanded"
																		}
																		>
																			<iframe id="infoTabFrame"
																				title="infoTabFrame"
																				onLoad={() => this.reportIframeLoaded("infoTabFrame")}
																				src={this.createValidPath(this.state.infoTabFrame, editableParam)}
																			/>
																			<footer>
																				<a data-translationkey="expand"
																					data-expand={false}
																					onClick={e => this.togglePanelView(e)}
																					href="#">
																					{this.props.translations.expand}
																				</a>
																				<Icon type="down" className="expand-icon" />
																			</footer>
																		</div>
																	</Panel>
																</Collapse>
															</div>
														</TabPane>
													)}

												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.party"] &&
													!this.props.printed && (
														<TabPane tab={this.props.translations.partyInfo ? this.props.translations.partyInfo : "Party Info"} key="12">
															<PartyInfo
																loadConfig={this.props.loadConfig}
																showPartytagTextarea={true}
																showSGCode={true}
																id={this.props.approveAdmaterialId}
																translations={this.props.translations}
																specId={this.props.specId}
																internal={this.props.internal}
																handlePartyChange={this.handlePartyChange} />
														</TabPane>
													)}
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.notes"] &&
													(this.state.showNotes || devMode) && (
														<TabPane tab={this.props.translations.notes} key="11">
															<Notes internal={this.props.internal}
																translations={this.props.translations}
																specId={this.props.specId}
																noteSaved={this.noteSaved} />
														</TabPane>
													)}
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.files"] &&
													(role !== "CLIENT" || !this.props.assetView) &&
													(this.state.showFiles /*|| devMode */) && (
														<TabPane tab={this.props.translations.reportTab2} key="9">
															<FileList
																updateMaterial={this.updateMaterial}
																admaterial={null}
																matspec={this.props.specId}
															/>
														</TabPane>
													)}
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.assets"] &&
													(role !== "CLIENT" ||
														(this.props.productionad ||
															(this.props.loadConfig && !this.props.loadConfig.assetTabOnlyForProduction)) /*&& this.state.showAssets*/ ||
														devMode) &&
													this.props.loadConfig &&
													this.props.loadConfig.assetShowInfo !== "top" && (
														<TabPane tab={this.props.translations.assets} key="7" style={{ border: "none" }}>
															<Collapse defaultActiveKey={["1", "2"]}>
																<Panel header={this.props.translations.assets} key="1">
																	<div className="panel-container">
																		<Assets
																			matspecid={this.state.matspecId ? this.state.matspecId : this.props.specId}
																			assetToMaterial={this.assetToMaterial}
																			admaterialid={this.state.admaterialid ? this.state.admaterialid : this.props.approveAdmaterialId}
																			canCreateAsset={this.state.canCreateAsset}
																			loadConfig={this.props.loadConfig}
																			editableView={this.props.editableView}
																			newAssetIds={this.props.newAssetIds}
																			newAssetNoteId={this.state.newAssetNoteId}
																			translations={this.props.translations}
																			unsubmittedChanges={this.unsubmittedChanges}
																			assetView={this.props.assetView}
																			statusCode={statusCode}
																			newAsset={this.newAssetUploaded}
																		/>
																		<footer>
																			<a data-translationkey="expand"
																				data-expand={false}
																				onClick={e => this.togglePanelView(e)}
																				href="#">
																				{this.props.translations.expand}
																			</a>
																			<Icon type="down" className="expand-icon" />
																		</footer>
																	</div>
																</Panel>
																<Panel header={this.props.translations.orderInfoAssetTab} key="2">
																	<div data-translationkey="preflightError preflightValid"
																		className={data && data.haserrors ? "ix-report-status" : "ix-report-status ix-report-valid"}>
																		{data && data.haserrors
																			? this.props.translations.preflightError
																			: this.props.translations.preflightValid}
																	</div>
																	{this.state.assetTabFrame && (
																		<iframe id="assetTabFrame"
																			title="assetTabFrame"
																			onLoad={() => this.reportIframeLoaded("assetTabFrame")}
																			style={{ border: "none" }}
																			src={this.createValidPath(this.state.assetTabFrame, editableParam)} />
																	)}
																</Panel>
															</Collapse>
														</TabPane>
													)}
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.assets"] &&
													(devMode ||
														role !== "CLIENT" ||
														(this.props.productionad ||
															(this.props.loadConfig && !this.props.loadConfig.assetTabOnlyForProduction))) /*&& this.state.showAssets*/ &&
													this.props.loadConfig && this.props.loadConfig.assetShowInfo === "top" && (
														<TabPane tab={this.props.translations.assets} key="7" style={{ border: "none" }}>
															<Collapse defaultActiveKey={["1", "2"]}>
																<Panel header={this.props.translations.orderInfoAssetTab} key="2">
																	<div className="panel-container">
																		<div data-translationkey="preflightError preflightValid"
																			className={data && data.haserrors ? "ix-report-status" : "ix-report-status ix-report-valid"}>
																			{data && data.haserrors ? this.props.translations.preflightError : this.props.translations.preflightValid}
																		</div>
																		{this.state.assetTabFrame &&
																			(<div>
																				<iframe id="assetTabFrame"
																					title="assetTabFrame"
																					onLoad={() => this.reportIframeLoaded("assetTabFrame")}
																					style={{ border: "none" }}
																					src={this.createValidPath(this.state.assetTabFrame, editableParam)} />
																			</div>)}
																		<footer>
																			<a data-translationkey="expand"
																				data-expand={false}
																				onClick={e => this.togglePanelView(e)}
																				href="#">
																				{this.props.translations.expand}
																			</a>
																			<Icon type="down" className="expand-icon" />
																		</footer>
																	</div>
																</Panel>
																<Panel header={this.props.translations.assets} key="1">
																	<Assets
																		matspecid={this.state.matspecId ? this.state.matspecId : this.props.specId}
																		assetToMaterial={this.assetToMaterial}
																		admaterialid={this.state.admaterialid ? this.state.admaterialid : this.props.approveAdmaterialId}
																		loadConfig={this.props.loadConfig}
																		canCreateAsset={this.state.canCreateAsset}
																		editableView={this.props.editableView}
																		newAssetIds={this.props.newAssetIds}
																		newAssetNoteId={this.state.newAssetNoteId}
																		translations={this.props.translations}
																		unsubmittedChanges={this.unsubmittedChanges}
																		assetView={this.props.assetView}
																		statusCode={statusCode}
																		newAsset={this.newAssetUploaded}
																	/>
																</Panel>
															</Collapse>
														</TabPane>
													)}
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.annotations"] &&
													(devMode ||
														role !== "CLIENT" ||
														(this.props.productionad ||
															(this.props.loadConfig && !this.props.loadConfig.annotationTabOnlyForProduction))) /*&& this.state.showAnnotations*/ && (
														<TabPane tab={this.props.translations.annotations} key="5" style={{ border: "none", height: "calc(80vh / " + this.state.bodyZoom + ")" }}>
															<Collapse defaultActiveKey={["1", "2"]}>
																<Panel header={this.props.translations.annotations} key="1">
																	<div className="panel-container">
																		<AnnotationWidget
																			assetView={this.props.assetView}
																			admaterial={this.props.approveAdmaterialId}
																			annotations={this.state.annotations}
																			assetVisualId={this.props.assetVisualId}
																			currentUser={this.props.matspec.user.name}
																			currentUserId={this.props.matspec.user.id}
																			editableView={this.props.editableView}
																			preview={data ? data.previewUrl : ""}
																			bigpreviewArray={data && data.bigpreviewArray ? data.bigpreviewArray : ""}
																			specId={data ? data.matspecid : ""}
																			translations={this.props.translations}
																			setExpandablePanels={this.setExpandablePanels}
																		/>
																		<footer id="annotations__footer">
																			<a data-translationkey="expand"
																				data-expand={false}
																				onClick={e => this.togglePanelView(e)}
																				href="#">
																				{this.props.translations.expand}
																			</a>
																			<Icon type="down" className="expand-icon" />
																		</footer>
																	</div>
																</Panel>
																<Panel header={this.props.translations.orderInfoAnnotationTab} key="2">
																	<div data-translationkey="preflightError preflightValid"
																		className={data && data.haserrors ? "ix-report-status" : "ix-report-status ix-report-valid"}>
																		{data && data.haserrors ? this.props.translations.preflightError : this.props.translations.preflightValid}                                                            </div>
																	{this.state.annotationTabFrame && (
																		<iframe id="annotationTabFrame"
																			title="annotationTabFrame"
																			onLoad={() => this.reportIframeLoaded("annotationTabFrame")}
																			style={{ border: "none" }}
																			src={this.createValidPath(this.state.annotationTabFrame, editableParam)} />
																	)}
																</Panel>
															</Collapse>
														</TabPane>
													)}
												{this.props.loadConfig && this.props.loadConfig["web.details.tabs.history"] &&
													(role !== "CLIENT" ||
														(this.state.showHistory &&
															!this.props.assetView)) && (
														<TabPane tab={this.props.translations.history} key="6">
															<History
																printed={this.props.printed}
																bodyZoom={this.state.bodyZoom}
																matspecid={this.state.matspecId ? this.state.matspecId : this.props.specId}
																admaterial={this.state.admaterialid ? this.state.admaterialid : this.props.approveAdmaterialId}
																translations={this.props.translations}
															/>
														</TabPane>
													)}
											</Tabs>
										)}
								</Sider>
								<Layout>
									<Content>
										<div id="preloadingDetailsMask"
											data-visible={false && this.state.preloadingMask}
											className="preloading-mask">
											<Spin />
										</div>
										<ReportHeader
											allowDownload={this.props.allowDownload}
											showVideoControls={this.props.showVideoControls}
											audioAd={audioAd}
											imageAd={imageAd}
											videoAd={videoAd}
											approveAdmaterialId={this.props.approveAdmaterialId}
											assetView={this.props.assetView}
											assetVisualId={this.props.assetVisualId}
											buttons={data ? buttons : null}
											canCreateAnnotation={this.state.canCreateAnnotation}
											canDeleteAsset={this.state.canDeleteAsset}
											checkAnnotations={this.checkAnnotations}
											canCreateAssetVisual={this.state.canCreateAssetVisual}
											currentMaterials={this.state.currentMaterials}
											deleteVisual={this.deleteVisual}
											disabledStickyNote={this.props.assetView && !data}
											editableView={this.props.editableView}
											handleAnnotation={this.handleAnnotation}
											handleFitIn={this.handleFitIn}
											handleRealSize={this.handleRealSize}
											handleZoomIn={this.handleZoomIn}
											handleZoomOut={this.handleZoomOut}
											loadConfig={this.props.loadConfig}
											loadIframe={this.props.loadIframe}
											loadBookingData={this.props.loadBookingData}
											newAnnotations={this.state.newAnnotations}
											pageCount={this.state.pageCount}
											pageCountMax={this.props.pageCountMax}
											previewClick={this.props.previewClick}
											previewClickStatusCode={this.props.previewClickStatusCode}
											printed={this.props.printed}
											proofLink={this.props.proofLink}
											handleFrameStyles={this.handleFrameStyles(this.state.zoom)}
											productionad={this.props.productionad}
											playInnerAd={this.playInnerAd()}
											hasMaterial={this.props.hasMaterial}
											hasVisual={this.props.hasVisual}
											sidebarVisible={this.onCollapse}
											showNextPage={this.showNextPage}
											showPrevPage={this.showPrevPage}
											specId={this.props.specId}
											statusCode={statusCode}
											switchView={this.switchView}
											translations={this.props.translations}
											zoom={this.state.zoom}
											defaultZoom={this.state.defaultZoom}
										/>
										<div id="ReportPreviewContainer"
											className="text-center details-preview-container animation-false"
											style={{ height: "calc(80vh / " + this.state.bodyZoom + ")" }}
										>
											{showCarousel && (
												<div id="carouselContainer">
													<Tooltip title={translations.previousCreative} overlayClassName="nowrap">
														<Button type="secondary"
															icon="left"
															className="float-left"
															disabled={currentMaterialIndex === 0}
															onClick={() => this.loadPrevMaterial()} />
													</Tooltip>
													<Tooltip title={translations.nextCreative} overlayClassName="nowrap">
														<Button
															type="secondary"
															icon="right"
															className="float-right"
															disabled={currentMaterialIndex === currentMaterialsLength - 1}
															onClick={() => this.loadNextMaterial()}
														/>
													</Tooltip>
												</div>
											)}
											{!this.props.assetView && (
												<div className={data && data.haserrors ? "report-ribbon report-ribbon-invalid" : data && data.haserrors === true ? "report-ribbon" : "d-none"}>
													<span data-translationkey="preflightErrorRibbon preflightValidRibbon">
														{data && data.haserrors
															? this.props.translations.preflightErrorRibbon
															: this.props.translations.preflightValidRibbon}
													</span>
												</div>
											)}
											{(this.state.canCreateAsset || devMode) &&
												this.props.assetView &&
												data &&
												!data.hasVisual &&
												this.props.editableView &&
												this.state.canCreateAssetVisual && (
													<AssetUpload
														loadConfig={this.props.loadConfig}
														setNewAssets={this.setNewAssets}
														assetToMaterial={this.assetToMaterial}
														admaterialid={this.state.admaterialid ? this.state.admaterialid : this.props.approveAdmaterialId}
														materialSpecificationId={this.state.matspecId ? this.state.matspecId : this.props.specId}
														setAsVisual={true}
														translations={this.props.translations}
														reloadReport={this.reloadReport}
														unsubmittedChanges={this.unsubmittedChanges}
													/>
												)}
											{data &&
												(data.previewUrl ||
													data.originalUrl ||
													data.hasVisual) && (
													<div id="reportPreviewContainer">
														{data.originalUrl &&
															data.originalUrl.endsWith(".mp3") && (
																<audio controls>
																	<source src={imageUrlPath + data.originalUrl} type="audio/mpeg" />
															Your browser does not support the audio tag.
																</audio>
															)}
														{data.originalUrl &&
															(data.originalUrl.endsWith(".mp4") || data.originalUrl.endsWith(".webm")) ? (
																<video id="videoFrame" muted className="details-previewframe" style={{ transform: "scale(" + this.state.zoom + ")" }}>
																	<source src={data.originalUrl ? imageUrlPath + data.originalUrl : null} type="video/mp4" />
																	<source src={data.originalUrl ? imageUrlPath + data.originalUrl : null} type="video/ogg" />
															Your browser does not support the video tag.
																</video>
															) : (
																this.props.loadIframe &&
																data.originalUrl &&
																data.originalUrl.endsWith(".html") && (
																	<iframe
																		onLoad={() => this.reportIframeLoaded("previewFrame")}
																		id="previewFrame"
																		sandbox="allow-same-origin allow-scripts allow-popups"
																		title="previewFrame"
																		className="details-previewframe"
																		style={{
																			border: "none",
																			width: this.state.canvasWidth + 100,
																			height: this.state.canvasHeight + 100,
																			transform: "scale(" + this.state.zoom + ")",
																			transformOrigin: "0px 0px"
																		}}
																		src={data.originalUrl ? imageUrlPath + data.originalUrl : null}
																	/>
																)
															)}
														{data.urlFile && (
															<div id="previewTextContainer">
																<Icon type="file" />
																<a download className="open-asset-link" href={data.urlFile}>
																	{data.fileName}
																</a>
															</div>
														)}

														{data.files &&
															data.files[0] &&
															data.files[0].format === "mp3" ? (
																<img id="previewImage"
																	style={{ transform: "scale(" + this.state.zoom + ")" }}
																	className="d-none report-preview report-icon-preview"
																	src={Mp3Icon}
																	alt="preview"
																/>
															) : (
																<img id="previewImage"
																	style={{ transform: "scale(" + this.state.zoom + ")" }}
																	className={this.state.previewClassName ? this.state.previewClassName : "report-preview"}
																	src={data.previewUrl && !isGif
																		? data.previewUrl
																		: data.originalUrl &&
																			!data.originalUrl.endsWith("html")
																			? imageUrlPath + data.originalUrl
																			: Placeholder
																	}
																	alt="preview"
																/>
															)}
														<AnnotationCanvas
															assetView={this.props.assetView}
															admaterial={this.props.approveAdmaterialId}
															annotations={this.state.annotations}
															annotationType={this.state.annotationType}
															assetVisualId={this.props.assetVisualId}
															canSaveownAnnotation={this.state.canSaveownAnnotation}
															canDeleteAnnotation={this.state.canDeleteAnnotation}
															canSaveotherAnnotation={this.state.canSaveotherAnnotation}
															canvasHeight={this.state.canvasHeight}
															canvasWidth={this.state.canvasWidth}
															matspec={this.props.matspec}
															pageCount={this.state.pageCount}
															saveAnnotations={this.saveAnnotations}
															translations={this.props.translations}
															zoom={this.state.zoom}
															newAssetNote={this.newAssetNote}
															newAnnotations={this.state.newAnnotations}
															newAnnotationFlag={this.newAnnotationFlag}
															userId={this.props.matspec.user.id}
														/>
													</div>
												)}
										</div>
									</Content>
									<Footer>
										{this.props.changesButtons && renderButtons}
										{this.state.showTerms && (
											<div>
												<Checkbox onChange={this.onTermsChange}>
													{this.state.customFrameTerms &&
														this.state.customFrameTerms !== "#" ? (
															<a href={this.state.customFrameTerms} target="_blank">
																{this.props.translations.acceptTermsAndConditions ? this.props.translations.acceptTermsAndConditions : "Accept terms and conditions"}
															</a>
														) : this.props.translations
															.acceptTermsAndConditions ? (
																this.props.translations.acceptTermsAndConditions
															) : (
																"Accept terms and conditions"
															)}
												</Checkbox>
											</div>
										)}
									</Footer>
								</Layout>
							</Layout>
							<ConfirmationModal
								admaterialid={this.state.admaterialid}
								approveTrue={this.state.approveTrue}
								confirmationModalVisible={this.state.confirmationModalVisible}
								fileUrl={this.state.fileUrl}
								matspecId={this.state.matspecId}
								text={this.state.confirmationModalText}
								translations={this.props.translations}
							/>
						</div>
					</Modal>
				</div>
			);
		} else return null;
	}

	checkPermissions(statusCode) {
		hasPermissions("com.ix.adp.model.AssetVisual.create,com.ix.adp.model.Annotation.create,com.ix.adp.model.Annotation.saveown,com.ix.adp.model.Annotation.delete,com.ix.adp.model.Annotation.saveother,com.ix.adp.model.Asset.create,com.ix.adp.model.Asset.delete,web.details.tabs.annotations,web.details.tabs.assets,web.details.tabs.files,web.details.tabs.history,web.details.tabs.info,web.details.tabs.report,web.details.tabs.notes",
			statusCode,
			val => {
				if (val != null)
					this.setState({
						canCreateAssetVisual: val["com.ix.adp.model.AssetVisual.create"],
						canCreateAnnotation: val["com.ix.adp.model.Annotation.create"],
						canSaveownAnnotation: val["com.ix.adp.model.Annotation.saveown"],
						canDeleteAnnotation: val["com.ix.adp.model.Annotation.delete"],
						canSaveotherAnnotation: val["com.ix.adp.model.Annotation.saveother"],
						canCreateAsset: val["com.ix.adp.model.Asset.create"],
						canDeleteAsset: val["com.ix.adp.model.Asset.delete"],
						showAnnotations: val["web.details.tabs.annotations"],
						showAssets: val["web.details.tabs.assets"],
						showFiles: val["web.details.tabs.files"],
						showHistory: val["web.details.tabs.history"],
						showInfo: val["web.details.tabs.info"],
						showReport: val["web.details.tabs.report"],
						showNotes: val["web.details.tabs.notes"],
						isInitialized: true
					});
			}
		);
	}

	setZoom = () => {
		if (document.getElementsByClassName("ant-tabs-nav-wrap")[0])
			return setInitialBodyZoom();
		return setTimeout(() => this.setZoom(), 0);
	};

	setTab = _ => {
		let statusCode = this.getStatusCode(this.props.matspec, this.props.approveAdmaterialId, this.props.specId);
		if (statusCode === 518) {
			const annotationTab = document.getElementById("annotationTab");
			if (annotationTab) annotationTab.click();
			console.log('%c  %o ', 'background: green; color: white',);
		} else if (this.props.assetView) {
			const assetTab = document.getElementById("assetTab");
			if (assetTab) assetTab.click();
		}
	};

	componentDidMount() {
		this.setTab();
		this.setZoom();
		this.setReportPreviewContainerStyle();
		let statusCode = this.getStatusCode(this.props.matspec, this.props.approveAdmaterialId, this.props.specId);
		this.handleTerms();
		let browserUrl = new URL(window.location.href);
		browserUrl = browserUrl.href;
		const detailsMode = browserUrl.includes("mode=details");
		this.checkPermissions(statusCode);
		this.setState({
			defaultActiveKey: "",
			detailsMode
		});
	}

	componentWillUnmount() {
		const x = document.getElementById('assetTabFrame');
		if (x) {
			let assetTabContent;
			try {
				assetTabContent = x.contentDocument || x.contentWindow.document;
				const visualDescription = assetTabContent.getElementById('description');
				if (visualDescription && visualDescription.hasChangeListener) {
					visualDescription.hasChangeListener = false;
					visualDescription.removeEventListener('change');
				}
			}
			catch (e) {
				console.log('cors not allowed');
			}
		}

		const annotationTabFrame = document.getElementById('annotationTabFrame');
		if (!this.state.isOnAnnotationView) {
			this.setState({ isOnAnnotationView: true })
		}
		let annotationTabContent;
		try {
			annotationTabContent = annotationTabFrame.contentDocument || annotationTabFrame.contentWindow.document;
			const dataFields = annotationTabContent.querySelectorAll('[data-field]');
			dataFields.forEach((el) => el.removeEventListener('change'));
		} catch (e) {
			console.log('cors not allowed');
		}
	}

	setExpandablePanels = () => {
		setTimeout(() => {
			const panelContainers = document.getElementsByClassName("panel-container");
			for (let i = 0; i < panelContainers.length; i++) {
				panelContainers[i].classList.add("panel-container-expanded")
				/*const panelHeight = panelContainers[i].offsetHeight;
				if (panelHeight > 300)
		            panelContainers[i].classList.add("showExpand");
				else
		            panelContainers[i].classList.remove("showExpand");
				*/
			}
		}, 250);
	};

	getComponentWidth = id => {
		const component = document.getElementById(id);
		return component ? component.offsetWidth : null;
	};
	getComponentHeight = id => {
		const component = document.getElementById(id);
		return component ? component.offsetHeight : null;
	};

	getRealSizePreview = () => {
		const previewImage = document.getElementById("previewImage");
		const that = this;
		let naturalWidth = null;
		let naturalHeight = null;
		this.updateImageDimensions();
		if (previewImage)
			previewImage.onload = function () {
				naturalWidth = previewImage.naturalWidth;
				naturalHeight = previewImage.naturalHeight;
				const previewContainerWidth = that.getComponentWidth("ReportPreviewContainer");
				const previewContainerHeight = that.getComponentHeight("ReportPreviewContainer");
				that.setDefaultZoom(previewContainerWidth, previewContainerHeight, naturalWidth, naturalHeight);
			};
		else if (this.state.preloadingMask) this.setState({ preloadingMask: false });
	};
	updateImageDimensions = () => {
		const previewImage = document.getElementById("previewImage");
		const that = this;
		let naturalWidth = null;
		let naturalHeight = null;
		if (previewImage) {
			naturalWidth = previewImage.naturalWidth;
			naturalHeight = previewImage.naturalHeight;
			const previewContainerWidth = that.getComponentWidth("ReportPreviewContainer");
			const previewContainerHeight = that.getComponentHeight("ReportPreviewContainer");
			that.setDefaultZoom(previewContainerWidth, previewContainerHeight, naturalWidth, naturalHeight);
		} else if (this.state.preloadingMask) this.setState({ preloadingMask: false });
	};

	previewFrameZoom = zoom => {
		const previewFrame = document.getElementById("previewFrame");
		let bodyZoom = document.body.style.zoom ? document.body.style.zoom : 1;
		if (previewFrame) previewFrame.style.zoom = zoom / bodyZoom;
	};

	setDefaultZoom = (previewContainerWidth, previewContainerHeight, naturalWidth, naturalHeight) => {
		let defaultZoom = 1;
		let widthZoom = naturalWidth > previewContainerWidth ? previewContainerWidth / (naturalWidth + 75) : 1;
		let heightZoom = naturalHeight > previewContainerHeight ? previewContainerHeight / (naturalHeight + 75) : 1;
		const scalingFactor = widthZoom > heightZoom ? heightZoom : widthZoom;
		if (this.state.defaultZoom !== scalingFactor) {
			this.setState({
				defaultZoom: scalingFactor,
				zoom: scalingFactor
			});
		}
		this.previewFrameZoom(defaultZoom);
		const previewImage = document.getElementById("previewImage");
		if (previewImage && previewImage.complete && this.state.preloadingMask)
			this.setState({ preloadingMask: false });
	};
	checkNewNotesSaved = () => {
		if (this.state.newNotesSaved) {
			const approveOnly = document.getElementById("ad-approve-only");
			const approveWithChanges = document.getElementById("ad-approve-changes");
			const submit = document.getElementById("ad-submit");
			const submitOnly = document.getElementById("ad-submit-only");

			if (approveOnly) approveOnly.setAttribute("disabled", "disabled");
			if (approveWithChanges) {
				approveWithChanges.removeAttribute("disabled");
				approveWithChanges.classList.remove("d-none");
			}
			if (submit) {
				submit.removeAttribute("disabled");
				submit.classList.remove("d-none");
			}
			if (submitOnly) {
				submitOnly.removeAttribute("disabled");
				submitOnly.classList.remove("d-none");
			}
		}
	};

	updateMaterial = (material, matspecId) => {
		if (this.state.detailsMode)
			window.location.href = "./index.html?&mode=details&matspec=" + matspecId + "&admaterial=" + material.id;
		this.props.onOk();
	};

	handleMaterialSelect = value => {
		const { currentMaterials } = this.state;
		currentMaterials.map(material => {
			if (material.id === value)
				this.props.previewClick(true, material.id, material.materialSpecificationId, "[]", material.productionad, material.status.code, false);
		});
	};

	unsubmittedAnnotationsPrompt = () => {
		const { newAnnotations } = this.state;
		if (newAnnotations.length > 0) {
			const { translations } = this.props;
			Modal.warning({ title: translations.warning, content: translations.unsubmittedAnnotations });
			return false;
		}
		return true;
	};

	loadNextMaterial = () => {
		const { currentMaterials, currentMaterialIndex } = this.state;
		if (this.unsubmittedAnnotationsPrompt())
			currentMaterials.map((material, index) => {
				if (index === currentMaterialIndex + 1)
					this.handleMaterialSelect(material.id);
			});
	};
	loadPrevMaterial = () => {
		const { currentMaterials, currentMaterialIndex } = this.state;
		if (this.unsubmittedAnnotationsPrompt())
			currentMaterials.map((material, index) => {
				if (index === currentMaterialIndex - 1)
					this.handleMaterialSelect(material.id);
			});
	};

	readMatspecMaterials = () => {
		const { loadBookingData, specId, approveAdmaterialId, loadConfig } = this.props;
		const matspecs = loadBookingData.matspecs;
		let currentMaterials = [];
		matspecs.map(matspec => {
			if (matspec.id === specId)
				currentMaterials = matspec.admaterial;
		});
		currentMaterials.map((material, index) => {
			if (material.id === approveAdmaterialId)
				this.setState({ currentMaterialIndex: index });
		});
		const currentMaterialsLength = !this.props.printed && loadConfig && loadConfig["web.uploadadmaterial.dummycreative"] ? currentMaterials.length - 1 : currentMaterials.length;
		this.setState({
			currentMaterials,
			currentMaterialsLength,
			showCarousel: currentMaterialsLength > 1
		});
	};

	annotationChangeEvent = () => {
		this.setState({ showSubmitButton: true });
	};

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.specId !== this.props.specId ||
			prevProps.translations !== this.props.translations ||
			prevProps.approveAdmaterialId !== this.props.approveAdmaterialId) {
			let statusCode = this.getStatusCode(this.props.matspec, this.props.approveAdmaterialId, this.props.specId);
			this.checkPermissions(statusCode);
		}
		if (prevProps.approveAdmaterialId !== this.props.approveAdmaterialId) {
			this.setState({ newNotesSaved: false });
			this.setReportPreviewContainerStyle();
		}
		this.checkNewNotesSaved();
		this.getRealSizePreview();
		this.setExpandablePanels();

		const x = document.getElementById('assetTabFrame');
		if (x) {
			if (!this.state.isOnAssetView) {
				this.setState({ isOnAssetView: true })
			}
			let assetTabContent;
			try {
				assetTabContent = x.contentDocument || x.contentWindow.document;
				const visualDescription = assetTabContent.getElementById('description');
				if (visualDescription && !visualDescription.hasChangeListener) {
					this.setState({ hasVisualDescChanged: true })
					visualDescription.hasChangeListener = true;
				}
			}
			catch (e) {
				console.log('cors not allowed');
			}
		} else {
			if (this.isOnAssetView) {
				this.setState({ isOnAssetView: false });
			}
		}

		const annotationTabFrame = document.getElementById('annotationTabFrame');
		let annotationTabContent;
		if (annotationTabFrame) {
			if (!this.state.isOnAnnotationView) {
				try {
					annotationTabContent = annotationTabFrame.contentDocument || annotationTabFrame.contentWindow.document;
					const dataFields = annotationTabContent.querySelectorAll('[data-field]');
					dataFields.forEach((el) => el.addEventListener('change', this.annotationChangeEvent));
					this.setState({ isOnAnnotationView: true })
				} catch (e) {
					console.log('cors not allowed');
				}
			}

		} else {
			if (this.state.isOnAnnotationView) {
				this.setState({ isOnAnnotationView: false })
			}
		}
	}

	setReportPreviewContainerStyle = () => {
		const bodyZoom = document.body.style.zoom;
		if (bodyZoom && bodyZoom < 1) this.setState({ bodyZoom: bodyZoom });
		else this.setState({ bodyZoom: 1 });
	};

	createSrcPath = (data) => {
		if (data) {
			// if fake report is received
			if (devMode && data.xmllogUrl === "../tmp/fakereport.html")
				return htmlUrlPath + "/xServer/tmp/fakereport.html";
			return htmlUrlPath + data.xmllogUrl;
		}
		return "";
	}

	createValidPath = (path, editableParam) => {
		if (!path)
			return null;

		if (devMode) {
			if (path === "../tmp/fakereport.html")
				return htmlUrlPath + "/xServer/tmp/fakereport.html" + editableParam;
			return htmlUrlPath + path + editableParam;
		}
		return path + editableParam;
	}
}

export default Details;


// WEBPACK FOOTER //
// ./src/components/Details.js